(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

// Import constants
var {
  METERS_SQUARED,
  METERS
} = require('../constants.js');

// Define component
var AreaCalculator = {
  setup() {
    var {
      ref,
      computed,
      watch,
      nextTick
    } = Vue;
    var {
      useStore
    } = Vuex;
    var store = useStore();
    var inputMode = ref(store.state.rollWidths ? "dimensions" : "total-area");
    var productType = computed(() => store.state.productType);
    var rollWidths = computed(() => store.state.rollWidths);
    var area = computed({
      get: () => store.state.area,
      set: value => store.dispatch("setArea", value)
    });
    var width = computed({
      get: () => {
        if (!store.state.width && store.state.rollWidths) {
          store.dispatch("setWidth", store.state.rollWidths[0]);
          return store.state.rollWidths[0];
        }
        return store.state.width;
      },
      set: newWidth => {
        store.dispatch("setWidth", newWidth);

        // updating bulk order display text
        if (store.state.rollWidths && store.state.bulkOrderThreshold) {
          var bulkQtyElements = document.querySelectorAll('.roll-bulk-qty');
          var bulkThreshold = Math.round(newWidth * store.state.bulkOrderThreshold);
          bulkQtyElements.forEach(element => {
            element.innerText = 'Over ' + bulkThreshold + 'm²';
          });
        }
      }
    });
    var length = computed({
      get: () => {
        if (store.state.length === null && store.state.rollWidths) {
          var defaultLength = (1 / store.state.width).toFixed(2);
          store.dispatch("setLength", defaultLength);
          return defaultLength;
        }
        return store.state.length;
      },
      set: newLength => store.dispatch("setLength", newLength)
    });
    var toggleInputMode = () => {
      inputMode.value = inputMode.value === "dimensions" ? "total-area" : "dimensions";
      if (area.value != calculateProjectSize()) {
        nextTick(() => {
          width.value = "";
          length.value = "";
        });
      }
    };
    var calculateProjectSize = () => {
      if (area.value && inputMode.value === "total-area") {
        return area.value;
      }
      if (!width.value || !length.value) {
        return null;
      }
      return (width.value * length.value).toFixed(2);
    };
    watch([width, length], () => {
      if (width.value !== null && length.value !== null) {
        area.value = calculateProjectSize();
      }
    }, {
      immediate: true
    });
    return {
      inputMode,
      productType,
      rollWidths,
      area,
      width,
      length,
      toggleInputMode,
      store,
      METERS_SQUARED,
      METERS
    };
  },
  template: "\n  <div class=\"area-calculator-wrapper\">\n    <div v-if=\"productType == 'pack'\" class=\"w-full calc_meaurement-type-block\">\n      <div class=\"whitespace-nowrap input-label\">Measurement type</div>\n      <div class=\"toggle-wrapper type-toggle-main\">\n        <div class=\"toggle-container\" @click=\"toggleInputMode\">\n          <div id=\"areaCheck\" :class=\"{ checked: inputMode === 'total-area' }\">\n            Area\n          </div>\n          <div id=\"dimensionCheck\" :class=\"{ checked: inputMode === 'dimensions' }\">\n            W x L\n          </div>\n          <div class=\"slider\"></div>\n        </div>\n      </div>\n    </div>\n    <div v-else class=\"w-full\">\n      <div class=\"input-label\">Width</div>\n      <div class=\"w-full select-field-wrapper\">\n        <select class=\"w-full\" v-model=\"width\">\n          <option v-for=\"(widthValue, index) in rollWidths\" :key=\"index\">\n            {{ Number(widthValue) }}\n          </option>\n        </select>\n      </div>\n    </div>\n\n    <div class=\"flex flex-row gap-5 items-center w-full\">\n      <div v-if=\"inputMode === 'dimensions'\" class=\"w-auto calc_dimension-wrappers\">\n        <div class=\"flex space-x-2\">\n          <div class=\"w-full input-wrapper\" v-if=\"productType == 'pack'\">\n            <div class=\"input-label\">Width</div>\n            <div class=\"relative\">\n              <input type=\"number\" min=\"0\" max=\"1000\" v-model.number=\"width\" placeholder=\"E.g. 2\"\n                class=\"w-full input-field noscroll\" />\n              <span class=\"input-suffix\">{{ METERS }}</span>\n            </div>\n          </div>\n          <div class=\"w-full input-wrapper\">\n            <div class=\"input-label\">Length</div>\n            <div class=\"relative\">\n              <input type=\"number\" min=\"0\" max=\"1000\" v-model.number=\"length\" placeholder=\"E.g. 2\"\n                class=\"w-full input-field noscroll\" />\n              <span class=\"input-suffix\">{{ METERS }}</span>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div v-else class=\"w-full calc_dimension-wrappers\">\n        <div class=\"w-full input-wrapper\">\n          <div class=\"input-label\">Area</div>\n          <div class=\"relative\">\n            <input type=\"number\" min=\"0\" max=\"1000\" v-model.number=\"area\" placeholder=\"E.g. 2\"\n              class=\"w-full input-field noscroll\" />\n            <span class=\"input-suffix\">{{ METERS_SQUARED }}</span>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n    "
};

// Export the component using module.exports
module.exports = {
  AreaCalculator
};

},{"../constants.js":12}],2:[function(require,module,exports){
"use strict";

require("core-js/modules/es.promise.js");
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var {
  METERS_SQUARED
} = require('../constants.js');

// Define component
var CalculatorAccordions = {
  props: {
    measure: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    var {
      ref,
      computed,
      watch,
      onMounted
    } = Vue;
    var {
      useStore
    } = Vuex;
    var store = useStore();
    var productType = computed(() => store.state.productType);
    var bulkTiers = computed(() => store.state.bulkTiers);
    var bulkDiscountPrice = computed(() => store.state.bulkDiscountPrice);
    var bulkOrderThreshold = computed(() => store.state.bulkOrderThreshold);
    var isDiscounted = computed(() => store.getters.isDiscounted);
    var packsNeeded = computed(() => store.getters.packsNeeded);
    var computedArea = computed(() => store.getters.computedArea);
    var bulkAccordionRef = ref(null);
    var accordionState = ref({
      howToMeasure: false,
      bulkPricing: false
    });
    var getPricingTier = (tierValue, index) => {
      var tierDisplay = tierValue;
      if (store.state.productType == "pack") {
        if (bulkTiers.value[index + 1]) {
          tierDisplay += " - " + (bulkTiers.value[index + 1].bulk_discount_qty - 1);
        } else {
          tierDisplay += "+";
        }
        return tierDisplay + " packs";
      } else if (productType.value == 'accessory') {
        return tierDisplay + " units";
      } else {
        return tierDisplay + " " + METERS_SQUARED;
      }
    };
    var getDiscount = value => {
      var percentage = value / 100;
      var price = store.state.packSize ? store.state.defaultPrice / store.state.packSize : store.state.defaultPrice;
      var discount = price * percentage;
      return (price - discount).toFixed(2);
    };
    var isTierEnabled = (tier, index) => {
      if (store.state.productType == "pack" || store.state.productType == "accessory") {
        return tier.bulk_discount_qty <= packsNeeded.value && (index === bulkTiers.value.length - 1 || packsNeeded.value < bulkTiers.value[index + 1].bulk_discount_qty);
      }
      return tier.bulk_discount_qty <= computedArea.value && (index === bulkTiers.value.length - 1 || computedArea.value < bulkTiers.value[index + 1].bulk_discount_qty);
    };
    var slideToggle = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* (key) {
        var slideTo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var contentEl = jQuery("#".concat(key, "Content"));
        accordionState.value[key] = !accordionState.value[key];

        // Close all other accordions
        for (var accordionKey in accordionState.value) {
          if (accordionKey !== key && accordionState.value[accordionKey]) {
            accordionState.value[accordionKey] = false;
            var otherContentEl = jQuery("#".concat(accordionKey, "Content"));
            otherContentEl.slideToggle();
          }
        }
        contentEl.slideToggle();
        if (slideTo) {
          bulkAccordionRef.value.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });
        }
      });
      return function slideToggle(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    return {
      productType,
      bulkTiers,
      bulkDiscountPrice,
      bulkOrderThreshold,
      isDiscounted,
      packsNeeded,
      computedArea,
      bulkAccordionRef,
      accordionState,
      getPricingTier,
      getDiscount,
      isTierEnabled,
      slideToggle
    };
  },
  template: "\n        <div class=\"mb-5\">\n            <div v-if=\"measure\" class=\"calculator-accordion\">\n                <div class=\"flex items-center justify-between\" @click=\"slideToggle('howToMeasure')\">\n                    <div class=\"text-sm font-semibold leading-none text-shades-700\">\n                        How to measure\n                    </div>\n                    <div>\n                        <svg width=\"13\" height=\"10\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\">\n                            <path d=\"M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z\" />\n                        </svg>\n                    </div>\n                </div>\n                <div id=\"howToMeasureContent\" class=\"hidden text-sm text-shades-500\">\n                    <div class=\"pt-4 font-normal\">\n                        To measure your room for flooring, start by using a tape measure to\n                        find the length and width of the room. Measure from wall to wall at\n                        the longest points. For rooms with alcoves or closets, measure those\n                        areas separately. If the room has an irregular shape, divide it into\n                        smaller rectangles and measure each section individually.\n                    </div>\n                </div>\n            </div>\n        </div>\n    "
};

// Export the component using module.exports
module.exports = {
  CalculatorAccordions
};

},{"../constants.js":12,"core-js/modules/es.promise.js":138}],3:[function(require,module,exports){
"use strict";

require("core-js/modules/es.promise.js");
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// Import constants
var {
  formatCurrency
} = require('../constants.js');

// Define component
var ColourMatches = {
  props: {
    postItemToCart: {
      type: Function,
      required: true
    },
    addToCartLoading: {
      type: Boolean,
      required: true
    }
  },
  setup(props) {
    var {
      ref,
      computed
    } = Vue;
    var {
      useStore
    } = Vuex;
    var store = useStore();
    var quantities = ref({});
    var accessoryDescriptionName = computed(() => store.state.accessoryDescriptionName);
    var loading = ref(null);
    var colourMatches = computed(() => {
      if (vueAppData.cart.products && vueAppData.cart.products.length > 0) {
        var matches = vueAppData.cart.products.filter(product => product.matched_accessories.some(accessory => accessory.accessory_id == store.state.productId));

        // Initialize quantities for new matches if they don't exist
        matches.forEach(match => {
          match.accessory_colour = match.matched_accessories.find(accessory => accessory.accessory_id == store.state.productId).accessory_colour;
          if (!(match.cart_item_key in quantities.value)) {
            quantities.value[match.cart_item_key] = 0;
          }
        });
        return matches;
      }
      return [];
    });
    var addItemToCart = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* (quantity, accessoryOption, index) {
        if (quantity == 0 || quantity == null) {
          return;
        }
        var formData = new FormData();
        formData.append("action", "add_main_and_upsell_to_cart");
        formData.append("main_product_id", store.state.productId);
        formData.append("main_quantity", quantity);
        formData.append("weldrod_option", accessoryOption);
        loading.value = index;
        yield props.postItemToCart(formData);
        loading.value = null;
      });
      return function addItemToCart(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();
    return {
      accessoryDescriptionName,
      quantities,
      loading,
      colourMatches,
      addItemToCart,
      formatCurrency
    };
  },
  template: "\n        <template v-if=\"colourMatches.length > 0\">\n            <h2 class=\"text-shades-900\">Based on items in your cart</h2>\n            <p class=\"p-0 m-0 mb-3 text-sm text-shades-500\">\n                We've matched your {{ accessoryDescriptionName }} so you don't have to.\n            </p>\n            <div class=\"p-3 mb-5 rounded-lg border border-solid border-shades-100 bg-shades-50 last-of-type:mb-0\"\n                v-for=\"(matchProduct, index) in colourMatches\" \n                :key=\"index\">\n                \n                <!-- Product Info Row -->\n                <div class=\"flex items-start gap-3 mb-3\">\n                    <div class=\"w-14 h-14 overflow-hidden rounded-md bg-shades-200 shrink-0\">\n                        <img class=\"w-full h-full object-cover\" :src=\"matchProduct.image_url\" :alt=\"matchProduct.product_name\">\n                    </div>\n                    <div class=\"flex-1 min-w-0\">\n                        <div class=\"text-sm font-medium text-shades-800 line-clamp-2\">{{ matchProduct.product_name }}</div>\n                        <div class=\"mt-1 text-sm text-shades-600\">\n                            <span class=\"font-semibold text-shades-700\">\n                                {{ accessoryDescriptionName.charAt(0).toUpperCase() +\n                                    accessoryDescriptionName.slice(1) }} to match:\n                            </span> \n                            <span class=\"text-shades-800\">{{ matchProduct.accessory_colour }}</span>\n                        </div>\n                    </div>\n                </div>\n\n                <!-- Quantity & Add Button Row -->\n                <div class=\"flex items-center gap-2\">\n                    <div class=\"flex items-center border border-solid border-shades-200 rounded-lg bg-white overflow-hidden\">\n                        <button \n                            @click=\"quantities[matchProduct.cart_item_key] = Math.max(0, (quantities[matchProduct.cart_item_key] || 0) - 1)\"\n                            class=\"w-9 h-9 flex items-center justify-center text-shades-500 hover:bg-shades-50 transition-colors\">\n                            <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\"><path d=\"M5 12h14\"/></svg>\n                        </button>\n                        <input type=\"number\" \n                            class=\"w-12 h-9 text-center text-sm font-medium border-0 bg-transparent focus:outline-none focus:ring-0\"\n                            v-model=\"quantities[matchProduct.cart_item_key]\" \n                            min=\"0\">\n                        <button \n                            @click=\"quantities[matchProduct.cart_item_key] = (quantities[matchProduct.cart_item_key] || 0) + 1\"\n                            class=\"w-9 h-9 flex items-center justify-center text-shades-500 hover:bg-shades-50 transition-colors\">\n                            <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\"><path d=\"M12 5v14M5 12h14\"/></svg>\n                        </button>\n                    </div>\n                    <button @click=\"addItemToCart(quantities[matchProduct.cart_item_key], matchProduct.accessory_colour, index)\"\n                        class=\"flex-1 h-9 flex items-center justify-center gap-2 px-4 text-sm font-medium text-white bg-shades-800 rounded-lg hover:bg-shades-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed\"\n                        :disabled=\"quantities[matchProduct.cart_item_key] == 0 || quantities[matchProduct.cart_item_key] == null\">\n                        <svg v-if=\"loading == index\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"\n                            class=\"w-4 h-4 animate-spin\">\n                            <path fill=\"currentColor\" opacity=\".4\"\n                                d=\"M0 256C0 397.4 114.6 512 256 512c94.7 0 177.5-51.5 221.7-128l-55.4-32c-33.2 57.4-95.2 96-166.3 96C150 448 64 362 64 256S150 64 256 64l0-64C114.6 0 0 114.6 0 256z\" />\n                            <path fill=\"currentColor\"\n                                d=\"M477.7 384c21.8-37.7 34.3-81.4 34.3-128C512 114.6 397.4 0 256 0l0 64c106 0 192 86 192 192c0 35-9.4 67.8-25.7 96l55.4 32z\" />\n                        </svg>\n                        <span v-else>Add to Cart</span>\n                    </button>\n                </div>\n            </div>\n\n            <div class=\"flex items-center justify-center w-full mb-5\">\n                <span class=\"or-line\"></span>\n                <span class=\"px-5 text-lg font-bold text-shades-500\">or</span>\n                <span class=\"or-line\"></span>\n            </div>\n        </template>\n    "
};

// Export the component using module.exports
module.exports = {
  ColourMatches
};

},{"../constants.js":12,"core-js/modules/es.promise.js":138}],4:[function(require,module,exports){
"use strict";

// Define component
var PackCalculator = {
  setup() {
    var {
      ref,
      onUnmounted
    } = Vue;
    var {
      useStore
    } = Vuex;
    var store = useStore();
    var packs = ref(store.getters.packsNeeded);

    // Update packs when input changes
    var updatePacks = event => {
      var value = Math.floor(Number(event.target.value));
      if (!isNaN(value)) {
        store.dispatch("setPacks", value);
        store.dispatch("setQuantity", value);
      }
    };
    onUnmounted(() => {
      store.dispatch("setQuantity", null);
    });
    return {
      packs,
      updatePacks
    };
  },
  template: "\n        <div class=\"flex justify-between space-x-5\">\n            <div class=\"packs-input input-wrapper\">\n                <label class=\"input-label\">Number of packs</label>\n                <div class=\"relative\">\n                    <input\n                        type=\"number\"\n                        min=\"0\"\n                        max=\"1000\"\n                        @input=\"updatePacks\"\n                        v-model=\"packs\"\n                        placeholder=\"E.g. 6\"\n                        class=\"w-full input-field noscroll\"\n                    />\n                </div>\n            </div>\n        </div>\n    "
};

// Export the component using module.exports
module.exports = {
  PackCalculator
};

},{}],5:[function(require,module,exports){
"use strict";

require("core-js/modules/es.promise.js");
require("core-js/modules/es.promise.finally.js");
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// Import components
var {
  AreaCalculator
} = require("./AreaCalculator.js");
var {
  PackCalculator
} = require("./PackCalculator.js");
var {
  RoomCalculator
} = require("./RoomCalculator.js");
var {
  CalculatorAccordions
} = require("./CalculatorAccordions.js");
var {
  RugCalculator
} = require("./rug/RugCalculator.js");
var {
  ColourMatches
} = require("./ColourMatches.js");

// Import constants
var {
  formatCurrency
} = require("../constants.js");

// Define component
var ProductCalculator = {
  name: "ProductCalculator",
  components: {
    AreaCalculator,
    PackCalculator,
    RoomCalculator,
    CalculatorAccordions,
    RugCalculator,
    ColourMatches
  },
  setup() {
    var {
      ref,
      computed,
      onMounted,
      onUnmounted
    } = Vue;
    var {
      useStore
    } = Vuex;
    var store = useStore();
    var addCartError = ref(null);
    var packsNeeded = computed(() => store.getters.packsNeeded);
    var activeTab = ref("area");
    var productType = computed(() => store.state.productType);

    // Check if user has saved rooms (from cookies or server)
    var hasSavedRooms = computed(() => {
      var _window$fkCalculatorD;
      // Check server data for logged-in users
      if (((_window$fkCalculatorD = window.fkCalculatorData) === null || _window$fkCalculatorD === void 0 || (_window$fkCalculatorD = _window$fkCalculatorD.rooms) === null || _window$fkCalculatorD === void 0 ? void 0 : _window$fkCalculatorD.length) > 0) {
        return true;
      }
      // Check cookies for guests
      try {
        var roomsData = typeof Cookies !== 'undefined' ? Cookies.get("roomsData") : null;
        if (roomsData) {
          var rooms = JSON.parse(roomsData);
          return rooms && rooms.length > 0;
        }
      } catch (e) {}
      return false;
    });

    // Default to rooms mode if user has saved rooms
    var useRoomsMode = ref(hasSavedRooms.value);
    var showCreateRoomPanel = ref(false);
    var prefillRoomFromStore = ref(false);
    var backingSelected = ref("action");
    var productPrice = computed(() => store.getters.productPrice);
    var selectedWeldrodOption = ref(store.state.weldrodOptions ? store.state.weldrodOptions[0].option : "");
    var addToCartLoading = ref(false);

    // Custom variation selector state
    var selectorOpen = ref(false);
    var searchQuery = ref("");

    // Filtered options based on search query
    var filteredWeldrodOptions = computed(() => {
      if (!store.state.weldrodOptions) return [];
      if (!searchQuery.value) return store.state.weldrodOptions;
      var query = searchQuery.value.toLowerCase();
      return store.state.weldrodOptions.filter(opt => opt.option.toLowerCase().includes(query));
    });

    // Get the currently selected variation object
    var selectedVariation = computed(() => {
      if (!store.state.weldrodOptions || !selectedWeldrodOption.value) return null;
      return store.state.weldrodOptions.find(opt => opt.option === selectedWeldrodOption.value);
    });

    // Check if ALL options have images
    var allOptionsHaveImages = computed(() => {
      if (!store.state.weldrodOptions || store.state.weldrodOptions.length === 0) return false;
      return store.state.weldrodOptions.every(opt => opt.variation_image_url);
    });

    // Select a variation and close the panel
    var selectVariation = option => {
      selectedWeldrodOption.value = option;
      selectorOpen.value = false;
      searchQuery.value = "";
      // Remove body scroll lock on mobile
      document.body.classList.remove('variation-selector-open');
    };

    // Toggle selector panel
    var toggleSelector = () => {
      selectorOpen.value = !selectorOpen.value;
      if (!selectorOpen.value) {
        searchQuery.value = "";
        // Remove body scroll lock on mobile
        document.body.classList.remove('variation-selector-open');
      } else {
        // Add body scroll lock on mobile (only if screen is small)
        if (window.innerWidth < 768) {
          document.body.classList.add('variation-selector-open');
        }
      }
    };

    // Close selector when clicking outside
    var closeSelectorOnClickOutside = event => {
      var selector = document.querySelector('.variation-selector-container');
      if (selector && !selector.contains(event.target)) {
        selectorOpen.value = false;
        searchQuery.value = "";
        document.body.classList.remove('variation-selector-open');
      }
    };
    onMounted(() => {
      document.addEventListener('click', closeSelectorOnClickOutside);
    });
    var inputQuantity = computed({
      get: () => store.state.quantity,
      set: value => store.commit("setQuantity", value)
    });
    var addToCart = () => {
      if (productType.value == "pack") {
        return addPackToCart();
      } else if (productType.value == "roll") {
        return addRollToCart();
      }
      return addItemToCart();
    };
    var postItemToCart = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* (formData) {
        addToCartLoading.value = true;
        yield fetch(vueAppData.ajax_url, {
          method: "POST",
          body: formData
        }).then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Server responded with status " + response.status);
        }).then(data => {
          if (data.success) {
            triggerAddToCartStapeEvent(data.data);
            if (store.state.freeUpsells == null && (store.state.underlayProducts.length > 0 || store.state.adhesiveProducts.length > 0 || store.state.weldrodProducts.length > 0)) {
              openUpsells(data.data.product);
              var event = new CustomEvent("openMiniCartEvent", {
                detail: {
                  tab: "cart",
                  cart: data.data.cartData,
                  open: false
                }
              });
              document.dispatchEvent(event);
              return;
            }
            var event = new CustomEvent("openMiniCartEvent", {
              detail: {
                tab: "cart",
                cart: data.data.cartData
              }
            });
            document.dispatchEvent(event);
          } else {
            addCartError.value = data.data;
            console.log(addCartError.value);
          }
        }).catch(error => {
          console.error("Error adding to cart:", error);
        }).finally(() => {
          addToCartLoading.value = false;
        });
      });
      return function postItemToCart(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var triggerAddToCartStapeEvent = data => {
      if (typeof window.dataLayer !== "undefined" && typeof window.productDetails !== "undefined") {
        var _product$attributes, _product$attributes2;
        var product = data.product || {};
        var quantity = product.quantity || store.state.quantity || 1;
        var price = parseFloat(product.price) || window.productDetails.price || 0;
        window.dataLayer.push({
          ecommerce: null
        });
        window.dataLayer.push({
          event: "add_to_cart_stape",
          ecommerce: {
            currency: "GBP",
            value: price * quantity,
            items: [{
              item_id: product.id || window.productDetails.id || "",
              item_name: product.name || window.productDetails.name || "",
              affiliation: window.location.hostname,
              currency: "GBP",
              item_brand: ((_product$attributes = product.attributes) === null || _product$attributes === void 0 ? void 0 : _product$attributes.pa_brand) || window.productDetails.brand || "",
              item_category: ((_product$attributes2 = product.attributes) === null || _product$attributes2 === void 0 ? void 0 : _product$attributes2.pa_product_type) || window.productDetails.product_type || "",
              item_variant: product.variant || "",
              price: price,
              quantity: quantity
            }]
          }
        });
      }
    };
    var addItemToCart = () => {
      if (store.state.quantity == 0 || store.state.quantity == null) {
        return;
      }
      var formData = new FormData();
      formData.append("action", "add_main_and_upsell_to_cart");
      formData.append("main_product_id", store.state.productId);
      formData.append("main_quantity", store.state.quantity);
      if (selectedWeldrodOption.value) {
        formData.append("weldrod_option", selectedWeldrodOption.value);
      }
      if (store.state.productType == "Rug") {
        if (store.state.selectedSize) {
          var _store$state$selected;
          formData.append("rug_sku", (_store$state$selected = store.state.selectedSize) === null || _store$state$selected === void 0 ? void 0 : _store$state$selected.rug_sku);
        } else {
          return;
        }
      }
      postItemToCart(formData);
    };
    var addPackToCart = () => {
      if (store.getters.computedTotal <= 0) {
        return;
      }
      var formData = new FormData();
      formData.append("action", "add_main_and_upsell_to_cart");
      formData.append("main_product_id", store.state.productId);
      formData.append("main_quantity", store.getters.packsNeeded);
      postItemToCart(formData);
    };
    var addRollToCart = () => {
      if (store.getters.computedTotal <= 0) {
        return;
      }
      var formData = new FormData();
      formData.append("roll_width", store.state.width);
      formData.append("roll_length", store.state.length);
      formData.append("total_area", store.state.area);
      formData.append("action", "add_roll_to_cart");
      formData.append("unit_type", "m2");
      formData.append("product_id", store.state.productId);
      if (store.state.backingEnabled) {
        formData.append("backing_type", backingSelected.value);
      }
      postItemToCart(formData);
    };
    var openUpsells = product => {
      var openUpsellsEvent = new CustomEvent("openUpsellsEvent", {
        detail: {
          product,
          totalComputedArea: store.getters.totalComputedArea
        }
      });
      document.dispatchEvent(openUpsellsEvent);
    };

    // Single source of truth: disabled when there is no total calculated
    var addToCartDisabled = computed(() => {
      if (store.state.packSize || store.state.rollWidths) {
        return store.getters.computedTotal === 0;
      }
      if (store.state.productType === "Rug") {
        return !store.state.selectedSize;
      }
      return inputQuantity.value == 0 || inputQuantity.value == null;
    });
    var ADD_TO_CART_NO_TOTAL_MESSAGE = "Enter details above to calculate a total, then add to cart.";
    var WASTAGE_TOOLTIP_TEXT = "It's a good idea to order a little more flooring than your exact measurement. Rooms vary in size and shape, and you'll often need to cut boards to fit";
    var addToCartDisabledFeedback = ref(null);
    var wastageTooltipOpen = ref(null);
    var wastageTooltipAreaRef = ref(null);
    var toggleWastageMessage = source => {
      wastageTooltipOpen.value = wastageTooltipOpen.value === source ? null : source;
    };
    var onAddToCartClick = () => {
      if (addToCartDisabled.value) {
        addToCartDisabledFeedback.value = ADD_TO_CART_NO_TOTAL_MESSAGE;
        return;
      }
      addToCartDisabledFeedback.value = null;
      addToCart();
    };
    var isFinanceEligible = computed(() => store.getters.isFinanceEligible);
    var availableFinanceTerms = computed(() => store.getters.availableFinanceTerms);
    var maxFinanceTerm = computed(() => store.getters.maxFinanceTerm);
    var minMonthlyPayment = computed(() => store.getters.minMonthlyPayment);
    var computedTotal = computed(() => store.getters.computedTotal);
    var openFinanceCalculator = () => {
      if (typeof window.fkOpenFinanceModal === "function") {
        window.fkOpenFinanceModal(computedTotal.value, availableFinanceTerms.value);
      }
    };
    onMounted(() => {
      window.dataLayer = window.dataLayer || [];
    });

    // Watch computedTotal and dispatch event for external listeners
    var {
      watch
    } = Vue;
    watch(computedTotal, newTotal => {
      // Dispatch custom event for finance calculator hook
      var event = new CustomEvent("fkCalculatorTotalChanged", {
        detail: {
          total: newTotal,
          isFinanceEligible: isFinanceEligible.value,
          availableFinanceTerms: availableFinanceTerms.value,
          maxFinanceTerm: maxFinanceTerm.value,
          minMonthlyPayment: minMonthlyPayment.value
        }
      });
      document.dispatchEvent(event);
    });

    // Watch selectedWeldrodOption and dispatch event for gallery image swap
    watch(selectedWeldrodOption, newOption => {
      if (!store.state.weldrodOptions) return;

      // Find the selected variation from weldrodOptions
      var selectedVariation = store.state.weldrodOptions.find(opt => opt.option === newOption);
      if (selectedVariation) {
        var event = new CustomEvent("fkVariationImageChanged", {
          detail: {
            option: newOption,
            imageUrl: selectedVariation.variation_image_url || null,
            imageSrcset: selectedVariation.variation_image_srcset || null
          }
        });
        document.dispatchEvent(event);
      }
    });

    // Clear feedback when a total is calculated (button becomes enabled)
    watch(addToCartDisabled, disabled => {
      if (!disabled) addToCartDisabledFeedback.value = null;
    });
    return {
      store,
      addCartError,
      packsNeeded,
      activeTab,
      hasSavedRooms,
      useRoomsMode,
      showCreateRoomPanel,
      prefillRoomFromStore,
      productType,
      backingSelected,
      productPrice,
      selectedWeldrodOption,
      addToCartLoading,
      addToCartDisabled,
      ADD_TO_CART_NO_TOTAL_MESSAGE,
      WASTAGE_TOOLTIP_TEXT,
      addToCartDisabledFeedback,
      onAddToCartClick,
      inputQuantity,
      addToCart,
      postItemToCart,
      formatCurrency,
      isFinanceEligible,
      availableFinanceTerms,
      maxFinanceTerm,
      minMonthlyPayment,
      computedTotal,
      openFinanceCalculator,
      // Custom variation selector
      selectorOpen,
      searchQuery,
      filteredWeldrodOptions,
      selectedVariation,
      selectVariation,
      toggleSelector,
      allOptionsHaveImages,
      wastageTooltipOpen,
      wastageTooltipAreaRef,
      toggleWastageMessage
    };
  },
  template: "\n        <div>\n            <!-- Calculator for packs/rolls -->\n            <div v-if=\"store.state.packSize || store.state.rollWidths\">\n                <!-- Tab Navigation -->\n                <ul class=\"flex justify-between items-center p-0 m-0 list-none\" v-if=\"!store.state.rollWidths\">\n                    <li \n                        class=\"py-4 w-full font-bold text-center rounded-t-md cursor-pointer\"\n                        @click=\"activeTab = 'area'\"\n                        :class=\"{\n                            'bg-shades-50': activeTab == 'area',\n                            'text-shades-800': activeTab == 'area',\n                            'text-shades-500': activeTab != 'area'\n                        }\"\n                    >Calculate Flooring</li>\n                    \n                    <li \n                        v-if=\"store.state.packSize\"\n                        class=\"py-4 w-full font-bold text-center rounded-t-md cursor-pointer\"\n                        @click=\"activeTab = 'packs'\"\n                        :class=\"{\n                            'bg-shades-50': activeTab == 'packs',\n                            'text-shades-800': activeTab == 'packs',\n                            'text-shades-500': activeTab != 'packs'\n                        }\"\n                    >Order Packs</li>\n                </ul>\n\n                <!-- Calculator Content -->\n                <div \n                    class=\"relative p-5 bg-shades-50\"\n                    :class=\"{\n                        'rounded-tr-md': activeTab == 'area',\n                        'rounded-tl-md': activeTab == 'packs',\n                        'rounded-t-md': store.state.rollWidths\n                    }\"\n                >\n                    <!-- Calculate Flooring Tab Content -->\n                    <div v-if=\"activeTab == 'area' && !store.state.rollWidths\">\n                        \n                        <!-- Show toggle when user has saved rooms OR has clicked to create a room -->\n                        <template v-if=\"hasSavedRooms || showCreateRoomPanel\">\n                            <div class=\"flex gap-2 p-1 mb-4 rounded-lg bg-shades-100\">\n                                <button \n                                    @click=\"useRoomsMode = true\"\n                                    class=\"flex gap-2 justify-center items-center px-3 py-2 w-1/2 text-sm font-medium rounded-md transition-all\"\n                                    :class=\"useRoomsMode ? 'bg-white text-shades-800 shadow-sm' : 'text-shades-500 hover:text-shades-700'\"\n                                >\n                                    <svg class=\"w-4 h-4\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\">\n                                        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6\"/>\n                                    </svg>\n                                    {{ hasSavedRooms ? 'Saved Rooms' : 'Create Room' }}\n                                </button>\n                                <button \n                                    @click=\"useRoomsMode = false\"\n                                    class=\"flex gap-2 justify-center items-center px-3 py-2 w-1/2 text-sm font-medium rounded-md transition-all\"\n                                    :class=\"!useRoomsMode ? 'bg-white text-shades-800 shadow-sm' : 'text-shades-500 hover:text-shades-700'\"\n                                >\n                                    <svg class=\"w-4 h-4\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\">\n                                        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z\"/>\n                                    </svg>\n                                    Enter Area\n                                </button>\n                            </div>\n                            \n                            <!-- Rooms Calculator -->\n                            <div v-if=\"useRoomsMode\" class=\"pb-5\">\n                                <RoomCalculator :prefillFromStore=\"prefillRoomFromStore\" @room-saved=\"showCreateRoomPanel = true\" />\n                            </div>\n                            \n                            <!-- Manual Area Calculator (no \"save as room\" link since user already knows about rooms) -->\n                            <div v-else class=\"pb-5\">\n                                <AreaCalculator  />\n                            </div>\n                        </template>\n                        \n                        <!-- NO SAVED ROOMS and not creating: Show simple area calculator with prompts -->\n                        <template v-else>\n                            <div class=\"pb-5\">\n                                <AreaCalculator  />\n                            </div>\n                            \n                            <!-- Room creation prompts -->\n                            <div class=\"pb-5\">\n                                <!-- If area has a value, show \"Save this as a room\" -->\n                                <button \n                                    v-if=\"store.state.area > 0\"\n                                    @click=\"showCreateRoomPanel = true; useRoomsMode = true; prefillRoomFromStore = true\"\n                                    class=\"flex gap-2 items-center text-sm font-medium transition-colors btn-text-red\"\n                                >\n                                    <svg class=\"w-4 h-4\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\">\n                                        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4\"/>\n                                    </svg>\n                                    Save this as a room\n                                </button>\n                                \n                                <!-- Otherwise show \"Create a room\" prompt -->\n                                <button \n                                    v-else\n                                    @click=\"showCreateRoomPanel = true; useRoomsMode = true; prefillRoomFromStore = false\"\n                                    class=\"flex gap-2 items-center text-sm font-medium transition-colors text-shades-500 hover:text-shades-700\"\n                                >\n                                    <svg class=\"w-4 h-4\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\">\n                                        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6\"/>\n                                    </svg>\n                                    Create a room to save your measurements\n                                </button>\n                            </div>\n                        </template>\n                    </div>\n                    \n                    <!-- Other tabs (Packs) or Rolls -->\n                    <div v-else class=\"pb-5\">\n                        <AreaCalculator v-if=\"activeTab == 'area'\"  />\n                        <PackCalculator v-if=\"activeTab == 'packs'\" />\n                    </div>\n\n                    <!-- Wastage section: tooltips open on click/touch -->\n                    <div v-if=\"productType == 'pack' && computedTotal > 0\" ref=\"wastageTooltipAreaRef\">\n                        <!-- Wastage Option: show when user doesn't have 10% extra yet, or when they've manually enabled it (so they can turn it off) -->\n                        <div v-if=\"store.getters.showWastageOption || store.state.recommendedWastage\" class=\"flex items-center pb-5 space-x-2 text-base font-normal text-shades-700 recommendedWastage\">\n                            <input id=\"wastage-check\" type=\"checkbox\" v-model=\"store.state.recommendedWastage\" />\n                            <label for=\"wastage-check\" class=\"text-sm text-shades-700\">Add 10% for wastage (Recommended)</label>\n                            <span\n                                class=\"inline-flex relative cursor-pointer shrink-0 touch-manipulation\"\n                                @click.stop=\"toggleWastageMessage('checkbox')\"\n                                aria-label=\"More about wastage\"\n                                role=\"button\"\n                                tabindex=\"0\"\n                                @keydown.enter.prevent=\"toggleWastageMessage('checkbox')\"\n                                @keydown.space.prevent=\"toggleWastageMessage('checkbox')\"\n                            >\n                                <svg class=\"w-4 h-4 text-shades-500\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" aria-hidden=\"true\">\n                                    <path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z\" />\n                                </svg>\n                                </span>\n                            </div>\n                                \n\n                        <!-- 10% wastage included (when order already has enough extra from rounding, and user hasn't manually enabled wastage) -->\n                        <div v-if=\"store.getters.hasBuiltInWastage && !store.state.recommendedWastage\" class=\"flex items-center pb-5 space-x-2 text-base font-normal text-shades-700\">\n                            <span class=\"text-sm text-shades-700\">10% wastage is included</span>\n                            <span\n                                class=\"inline-flex relative cursor-pointer shrink-0 touch-manipulation\"\n                                @click.stop=\"toggleWastageMessage('included')\"\n                                aria-label=\"More about wastage\"\n                                role=\"button\"\n                                tabindex=\"0\"\n                                @keydown.enter.prevent=\"toggleWastageMessage('included')\"\n                                @keydown.space.prevent=\"toggleWastageMessage('included')\"\n                            >\n                                <svg class=\"w-4 h-4 text-shades-500\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" aria-hidden=\"true\">\n                                    <path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z\" />\n                                </svg>\n                                </span>\n                          </div>\n\n                        <div v-if=\"wastageTooltipOpen\" class=\"mb-5 text-sm text-shades-700\">\n                            <div v-if=\"wastageTooltipOpen === 'checkbox'\">\n                                {{ WASTAGE_TOOLTIP_TEXT }}\n                            </div>\n                            <div v-if=\"wastageTooltipOpen === 'included'\">\n                                {{ WASTAGE_TOOLTIP_TEXT }}\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Backing Options -->\n                    <div v-if=\"store.state.backingEnabled || store.state.hybridEnabled\" class=\"pb-3\">\n                        <div class=\"input-label\">Backing</div>\n                        <div class=\"flex flex-wrap items-center space-x-2 sm:flex-nowrap text-shades-500\">\n                            <div \n                                v-if=\"store.state.backingEnabled\"\n                                class=\"backing-button\"\n                                @click=\"backingSelected = 'action'\"\n                                :class=\"{ active: backingSelected == 'action' }\"\n                            >Action</div>\n                            <div \n                                v-if=\"store.state.backingEnabled\"\n                                class=\"backing-button\"\n                                @click=\"backingSelected = 'felt'\"\n                                :class=\"{ active: backingSelected == 'felt' }\"\n                            >Felt</div>\n                            <div \n                                v-if=\"store.state.hybridEnabled\"\n                                class=\"backing-button\"\n                                @click=\"backingSelected = 'hybrid'\"\n                                :class=\"{ active: backingSelected == 'hybrid' }\"\n                            >Hybrid</div>\n                        </div>\n                    </div>\n\n                    <!-- Price Display -->\n                    <div v-if=\"computedTotal > 0\">\n                        <div class=\"pb-3 text-3xl font-semibold leading-none text-shades-800\" id=\"total-price\">\n                            {{ formatCurrency(store.getters.computedTotal) }}\n                            <span class=\"text-sm font-normal\">inc VAT</span>\n                        </div>\n                        <div class=\"flex items-center text-sm leading-tight text-shades-500\">\n                            <div v-if=\"store.state.packSize\">\n                                The total price above is for\n                                <span class=\"font-bold\">{{ packsNeeded }} {{ \"pack\" + (packsNeeded == 1 ? \"\" : \"s\") }}</span>\n                                of flooring, covering an area of\n                                <span class=\"font-bold\">{{ store.getters.totalComputedArea.toFixed(2) + store.getters.unitSquaredText }}</span>\n                            </div>\n                            <div v-else-if=\"store.state.rollWidths\">\n                                The total price above is for\n                                <span class=\"font-bold\">{{ store.getters.totalComputedArea.toFixed(2) + store.getters.unitSquaredText }}</span>\n                                of flooring\n                            </div>\n                        </div>\n                    </div>\n\n                    <!-- Add to Cart Button -->\n                    <div class=\"pt-5\">\n                        <button\n                            @click=\"onAddToCartClick\"\n                            class=\"w-full btn btn-red btn-icon add-to-cart-btn-main\"\n                            :class=\"{ 'btn-disabled': addToCartDisabled }\"\n                            :title=\"addToCartDisabled ? ADD_TO_CART_NO_TOTAL_MESSAGE : ''\"\n                            :aria-disabled=\"addToCartDisabled\"\n                        >\n                            <svg v-if=\"addToCartLoading\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" class=\"animate-spin\">\n                                <path class=\"fa-secondary\" opacity=\".4\" d=\"M0 256C0 397.4 114.6 512 256 512c94.7 0 177.5-51.5 221.7-128l-55.4-32c-33.2 57.4-95.2 96-166.3 96C150 448 64 362 64 256S150 64 256 64l0-64C114.6 0 0 114.6 0 256z\" />\n                                <path class=\"fa-primary\" d=\"M477.7 384c21.8-37.7 34.3-81.4 34.3-128C512 114.6 397.4 0 256 0l0 64c106 0 192 86 192 192c0 35-9.4 67.8-25.7 96l55.4 32z\" />\n                            </svg>\n                            <span v-if=\"!addToCartLoading\">Add to cart</span>\n                            <svg v-if=\"!addToCartLoading\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\">\n                                <path d=\"M248 72V48H200V72 232H40 16v48H40 200V440v24h48V440 280H408h24V232H408 248V72z\" />\n                            </svg>\n                        </button>\n                    </div>\n\n                    <div v-if=\"addToCartDisabledFeedback && addToCartDisabled\" class=\"pt-5 w-full text-sm text-center text-red-500\">{{ addToCartDisabledFeedback }}</div>\n                    <div v-if=\"addCartError\" class=\"pt-5 w-full text-sm text-center text-red-500\">{{ addCartError }}</div>\n                </div>\n            </div>\n            <div v-else>\n                <RugCalculator v-if=\"store.state.productType == 'Rug'\" :postItemToCart=\"postItemToCart\"\n                :addToCartLoading=\"addToCartLoading\" ref=\"rugCalculator\" />\n                \n                <!-- Regular accessory without weldrod options -->\n                <div v-if=\"store.state.productType == 'accessory' && !store.state.weldrodOptions\" class=\"p-5 rounded-t-md bg-shades-50\">\n                    <div class=\"mb-[30px]\">\n                        <div class=\"w-full mb-[10px] text-shades-700\">Quantity</div>\n                        <div class=\"flex justify-between items-center\">\n                            <input class=\"input-field\" type=\"number\" v-model=\"inputQuantity\" min=\"1\" />\n                            <div class=\"text-[30px] font-semibold text-shades-800\">\n                            {{ formatCurrency(inputQuantity * productPrice) }}\n                            <span class=\"text-sm font-normal\">inc VAT</span>\n                            </div>\n                        </div>\n                    </div>\n                <div>\n                    <button @click=\"onAddToCartClick\" class=\"w-full btn btn-secondary btn-icon\"\n                    :class=\"{ 'btn-disabled': addToCartDisabled }\"\n                    :title=\"addToCartDisabled ? ADD_TO_CART_NO_TOTAL_MESSAGE : ''\"\n                    :aria-disabled=\"addToCartDisabled\">\n                        <svg v-if=\"addToCartLoading\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" class=\"animate-spin\">\n                            <path class=\"fa-secondary\" opacity=\".4\"\n                            d=\"M0 256C0 397.4 114.6 512 256 512c94.7 0 177.5-51.5 221.7-128l-55.4-32c-33.2 57.4-95.2 96-166.3 96C150 448 64 362 64 256S150 64 256 64l0-64C114.6 0 0 114.6 0 256z\" />\n                            <path class=\"fa-primary\"\n                            d=\"M477.7 384c21.8-37.7 34.3-81.4 34.3-128C512 114.6 397.4 0 256 0l0 64c106 0 192 86 192 192c0 35-9.4 67.8-25.7 96l55.4 32z\" />\n                        </svg>\n\n                        <span v-if=\"!addToCartLoading\">Add to cart</span>\n                        <svg v-if=\"!addToCartLoading\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\">\n                            <path d=\"M248 72V48H200V72 232H40 16v48H40 200V440v24h48V440 280H408h24V232H408 248V72z\" />\n                        </svg>\n                    </button>\n                </div>\n                    <div v-if=\"addToCartDisabledFeedback && addToCartDisabled\" class=\"pt-5 w-full text-sm text-center text-red-500\">{{ addToCartDisabledFeedback }}</div>\n                    <div v-if=\"addCartError\" class=\"pt-5 w-full text-sm text-center text-red-500\">{{ addCartError }}</div>\n                </div>\n\n                <div class=\"mb-[30px]\" v-if=\"store.state.weldrodOptions\">\n                    <ColourMatches :postItemToCart=\"postItemToCart\" :addToCartLoading=\"addToCartLoading\" />\n\n                    <div class=\"w-full mb-[10px] text-shades-700 text-sm\">Select a colour</div>\n                    \n                    <div class=\"relative mb-6 variation-selector-container\">\n                        <!-- Trigger Button -->\n                        <button \n                            @click.stop=\"toggleSelector\" \n                            type=\"button\"\n                            class=\"flex gap-2 justify-between items-center p-3 mb-2 w-full bg-white rounded-lg border border-solid transition-all duration-200 cursor-pointer variation-trigger border-shades-100 hover:border-shades-300\"\n                        >\n                            <div class=\"flex gap-2 items-center min-w-0\">\n                                <template v-if=\"allOptionsHaveImages\">\n                                    <div \n                                        v-if=\"selectedVariation?.variation_image_url\" \n                                        class=\"overflow-hidden flex-shrink-0 w-10 h-10 rounded bg-shades-100\"\n                                    >\n                                        <img \n                                            :src=\"selectedVariation.variation_image_url + '?width=80&height=80&quality=85&format=webp'\" \n                                            :alt=\"selectedWeldrodOption\"\n                                            class=\"object-cover w-full h-full\"\n                                        />\n                                    </div>\n                                </template>\n                                <span class=\"text-sm truncate text-shades-800\">{{ selectedWeldrodOption }}</span>\n                            </div>\n                            <svg \n                                class=\"flex-shrink-0 w-4 h-4 transition-transform duration-200 text-shades-500\" \n                                :class=\"{ 'rotate-180': selectorOpen }\"\n                                fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\"\n                            >\n                                <path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M19 9l-7 7-7-7\" />\n                            </svg>\n                        </button>\n\n                        <div \n                            v-if=\"selectorOpen\"\n                            class=\"variation-backdrop\"\n                            @click=\"toggleSelector\"\n                        ></div>\n                        \n                        <!-- Panel -->\n                        <div \n                            v-if=\"selectorOpen\"\n                            class=\"overflow-hidden rounded-lg border shadow-lg variation-panel border-shades-200\"\n                            @click.stop\n                        >\n                            <!-- Mobile Header with close button -->\n                            <div class=\"variation-panel-header\">\n                                <span class=\"text-base font-semibold text-shades-800\">Select a colour</span>\n                                <button \n                                    @click=\"toggleSelector\"\n                                    class=\"p-1.5 rounded-full transition-colors hover:bg-shades-100\"\n                                >\n                                    <svg class=\"w-5 h-5 text-shades-600\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\">\n                                        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M6 18L18 6M6 6l12 12\" />\n                                    </svg>\n                                </button>\n                            </div>\n\n                            <!-- Search Box -->\n                            <div class=\"p-2 bg-white border-b border-shades-100\">\n                                <div class=\"flex relative items-center\">\n                                    <svg class=\"absolute left-2.5 w-4 h-4 pointer-events-none text-shades-400\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\">\n                                        <path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z\" />\n                                    </svg>\n                                    <input \n                                        v-model=\"searchQuery\"\n                                        type=\"text\" \n                                        placeholder=\"Search colours...\" \n                                        class=\"py-2 pr-3 pl-10 w-full text-sm rounded-lg border transition-all bg-shades-50 border-shades-200 focus:ring-1 focus:ring-brand-300 focus:bg-white\"\n                                        @click.stop\n                                    />\n                                </div>\n                            </div>\n\n                            <!-- Options List -->\n                            <div class=\"variation-options-list\">\n                                <div \n                                    v-for=\"(option, index) in filteredWeldrodOptions\" \n                                    :key=\"index\"\n                                    @click=\"selectVariation(option.option)\"\n                                    class=\"flex gap-2 items-center p-2 transition-colors cursor-pointer hover:bg-shades-50\"\n                                    :class=\"{ 'bg-brand-300/10': option.option === selectedWeldrodOption }\"\n                                >\n                                    <!-- Option Thumbnail (only if ALL options have images) -->\n                                    <template v-if=\"allOptionsHaveImages\">\n                                        <div \n                                            v-if=\"option.variation_image_url\" \n                                            class=\"overflow-hidden flex-shrink-0 w-10 h-10 rounded border transition-all\"\n                                            :class=\"option.option === selectedWeldrodOption ? 'border-shades-800' : 'border-shades-200'\"\n                                        >\n                                            <img \n                                                :src=\"option.variation_image_url + '?width=80&height=80&quality=85&format=webp'\" \n                                                :alt=\"option.option\"\n                                                class=\"object-cover w-full h-full\"\n                                                loading=\"lazy\"\n                                            />\n                                        </div>\n                                    </template>\n\n                                    <!-- Option Name -->\n                                    <span \n                                        class=\"flex-1 text-sm\"\n                                        :class=\"option.option === selectedWeldrodOption ? 'text-shades-600 font-medium' : 'text-shades-700'\"\n                                    >{{ option.option }}</span>\n\n                                    <!-- Checkmark for selected -->\n                                    <svg \n                                        v-if=\"option.option === selectedWeldrodOption\"\n                                        class=\"flex-shrink-0 w-4 h-4 text-shades-600\" \n                                        fill=\"currentColor\" viewBox=\"0 0 20 20\"\n                                    >\n                                        <path fill-rule=\"evenodd\" d=\"M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z\" clip-rule=\"evenodd\" />\n                                    </svg>\n                                </div>\n\n                                <!-- No results -->\n                                <div v-if=\"filteredWeldrodOptions.length === 0\" class=\"p-6 text-center text-shades-500\">\n                                    <p class=\"text-sm\">No colours found</p>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                <div class=\"mb-[30px]\">\n                    <div class=\"w-full mb-[10px] text-shades-700\">Quantity</div>\n                    <div class=\"flex justify-between items-center\">\n                        <input class=\"input-field\" type=\"number\" v-model=\"inputQuantity\" />\n                        <div class=\"text-[30px] font-semibold text-shades-800\">\n                        {{ formatCurrency(inputQuantity * productPrice) }}\n                        <span class=\"text-sm font-normal\">inc VAT</span>\n                        </div>\n                    </div>\n                </div>\n                <div>\n                    <button @click=\"onAddToCartClick\" class=\"w-full btn btn-secondary btn-icon\"\n                    :class=\"{ 'btn-disabled': addToCartDisabled }\"\n                    :title=\"addToCartDisabled ? ADD_TO_CART_NO_TOTAL_MESSAGE : ''\"\n                    :aria-disabled=\"addToCartDisabled\">\n                        <svg v-if=\"addToCartLoading\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" class=\"animate-spin\">\n                            <path class=\"fa-secondary\" opacity=\".4\"\n                            d=\"M0 256C0 397.4 114.6 512 256 512c94.7 0 177.5-51.5 221.7-128l-55.4-32c-33.2 57.4-95.2 96-166.3 96C150 448 64 362 64 256S150 64 256 64l0-64C114.6 0 0 114.6 0 256z\" />\n                            <path class=\"fa-primary\"\n                            d=\"M477.7 384c21.8-37.7 34.3-81.4 34.3-128C512 114.6 397.4 0 256 0l0 64c106 0 192 86 192 192c0 35-9.4 67.8-25.7 96l55.4 32z\" />\n                        </svg>\n\n                        <span v-if=\"!addToCartLoading\">Add to cart</span>\n                        <svg v-if=\"!addToCartLoading\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\">\n                            <path d=\"M248 72V48H200V72 232H40 16v48H40 200V440v24h48V440 280H408h24V232H408 248V72z\" />\n                        </svg>\n                    </button>\n                </div>\n                <div v-if=\"addToCartDisabledFeedback && addToCartDisabled\" class=\"pt-5 w-full text-sm text-center text-red-500\">{{ addToCartDisabledFeedback }}</div>\n            </div>\n        </div>\n    "
};

// Export the component using module.exports
module.exports = {
  ProductCalculator
};

},{"../constants.js":12,"./AreaCalculator.js":1,"./CalculatorAccordions.js":2,"./ColourMatches.js":3,"./PackCalculator.js":4,"./RoomCalculator.js":6,"./rug/RugCalculator.js":8,"core-js/modules/es.promise.finally.js":137,"core-js/modules/es.promise.js":138}],6:[function(require,module,exports){
"use strict";

var {
  AreaCalculator
} = require('./AreaCalculator.js');
var {
  RoomForm
} = require('./RoomForm.js');
var RoomCalculator = {
  components: {
    RoomForm,
    AreaCalculator
  },
  props: {
    prefillFromStore: {
      type: Boolean,
      default: false
    }
  },
  emits: ['room-saved'],
  setup(props, _ref) {
    var {
      emit
    } = _ref;
    var {
      computed
    } = Vue;
    var {
      useStore
    } = Vuex;
    var store = useStore();
    var productType = computed(() => store.state.productType);
    var prefillData = computed(() => {
      if (!props.prefillFromStore || !store.state.area || store.state.area <= 0) {
        return null;
      }
      return {
        unitType: store.state.unit || 'm2',
        width: store.state.width || null,
        length: store.state.length || null,
        area: store.state.area
      };
    });
    var onRoomsChanged = _ref2 => {
      var {
        rooms,
        primaryRoomIndex
      } = _ref2;
      if (rooms.length > 0) {
        var projectSize = rooms[primaryRoomIndex - 1].projectSize;
        store.dispatch('setUnit', 'm2');
        if (store.state.productType === 'roll') {
          var rollWidth = store.state.rollWidths[0];
          var rollLength = projectSize / Number(rollWidth);
          store.dispatch('setWidth', Number(rollWidth));
          store.dispatch('setLength', Number(rollLength).toFixed(2));
          store.dispatch('setArea', Number(rollLength) * Number(rollWidth));
        } else {
          store.dispatch('setArea', projectSize);
        }
      }
    };
    var onRoomDeleted = _ref3 => {
      var {
        rooms
      } = _ref3;
      if (rooms.length === 0) {
        store.dispatch('setArea', 0);
        store.dispatch('setLength', 0);
      }
    };
    var onRoomSaved = () => {
      emit('room-saved');
    };
    return {
      productType,
      prefillData,
      onRoomsChanged,
      onRoomDeleted,
      onRoomSaved
    };
  },
  template: "\n\t\t<RoomForm\n\t\t\tvariant=\"product\"\n\t\t\t:prefillData=\"prefillData\"\n\t\t\t@rooms-changed=\"onRoomsChanged\"\n\t\t\t@room-deleted=\"onRoomDeleted\"\n\t\t\t@room-saved=\"onRoomSaved\"\n\t\t>\n\t\t\t<template #room-list-extra>\n\t\t\t\t<AreaCalculator v-if=\"productType == 'roll'\" class=\"mt-5\" />\n\t\t\t</template>\n\t\t</RoomForm>\n\t"
};
module.exports = {
  RoomCalculator
};

},{"./AreaCalculator.js":1,"./RoomForm.js":7}],7:[function(require,module,exports){
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var {
  METERS_SQUARED,
  METERS
} = require('../constants.js');
var {
  useRooms
} = require('../composables/useRooms.js');
var RoomForm = {
  props: {
    variant: {
      type: String,
      default: 'product',
      validator: v => ['product', 'category'].includes(v)
    },
    prefillData: {
      type: Object,
      default: null
    }
  },
  emits: ['room-saved', 'room-deleted', 'rooms-changed'],
  setup(props, _ref) {
    var {
      emit
    } = _ref;
    var {
      watch,
      onMounted
    } = Vue;
    var roomState = useRooms({
      onRoomsChanged: () => {
        emit('rooms-changed', {
          rooms: roomState.rooms.value,
          primaryRoomIndex: roomState.primaryRoomIndex.value
        });
      },
      onRoomDeleted: _ref2 => {
        var {
          deletedIndex
        } = _ref2;
        emit('room-deleted', {
          rooms: roomState.rooms.value,
          primaryRoomIndex: roomState.primaryRoomIndex.value,
          deletedIndex
        });
      }
    });

    // Wrap saveRoomData to also emit room-saved
    var originalSave = roomState.saveRoomData;
    roomState.saveRoomData = () => {
      var saved = originalSave();
      if (saved) {
        emit('room-saved', {
          rooms: roomState.rooms.value,
          primaryRoomIndex: roomState.primaryRoomIndex.value
        });
      }
    };

    // Watch rooms + primaryRoomIndex for changes (e.g. from setPrimaryRoom)
    watch([roomState.rooms, roomState.primaryRoomIndex], () => {
      emit('rooms-changed', {
        rooms: roomState.rooms.value,
        primaryRoomIndex: roomState.primaryRoomIndex.value
      });
    });
    onMounted(() => {
      roomState.loadRooms();

      // Prefill form from parent data (product page "Save this as a room" flow)
      if (props.prefillData) {
        roomState.createNewRoom.value = true;
        roomState.unitType.value = props.prefillData.unitType || 'm2';
        if (props.prefillData.width && props.prefillData.length) {
          roomState.inputMode.value = 'dimensions';
          roomState.width.value = Number(props.prefillData.width);
          roomState.length.value = Number(props.prefillData.length);
        } else if (props.prefillData.area) {
          roomState.inputMode.value = 'total-area';
          roomState.directArea.value = Number(props.prefillData.area);
        }
      }
    });
    return _objectSpread(_objectSpread({}, roomState), {}, {
      METERS_SQUARED,
      METERS,
      variant: props.variant
    });
  },
  template: "\n\t\t<div class=\"w-full\">\n\t\t\t<!-- Category: \"Calculate your flooring\" initial button -->\n\t\t\t<button\n\t\t\t\tv-if=\"variant === 'category' && rooms.length === 0 && !createNewRoom\"\n\t\t\t\tclass=\"w-full btn btn-secondary btn-icon lg:w-auto\"\n\t\t\t\t@click=\"createNewRoom = true\"\n\t\t\t>\n\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 384 512\">\n\t\t\t\t\t<path d=\"M336 176H48V464H336V176zm0-48V48H48v80H336zm48 0v24 24V464v48H336 48 0V464 176 152 128 48 0H48 336h48V48v80zM80 208h48v48H80V208zm48 88v48H80V296h48zM80 384H216v48H80V384zM216 208v48H168V208h48zm-48 88h48v48H168V296zm136-88v48H256V208h48zm-48 88h48v48H256V296zm48 88v48H256V384h48z\" />\n\t\t\t\t</svg>\n\t\t\t\t<span>Calculate your flooring</span>\n\t\t\t</button>\n\n\t\t\t<!-- Room creation / edit form -->\n\t\t\t<div\n\t\t\t\tv-else-if=\"createNewRoom || rooms.length == 0 || modifyRoom\"\n\t\t\t\t:class=\"variant === 'category' ? 'p-4 w-full rounded-md bg-shades-50' : 'w-full bg-gray-100 rounded-md'\"\n\t\t\t>\n\t\t\t\t<div class=\"flex justify-between items-center\">\n\t\t\t\t\t<component\n\t\t\t\t\t\t:is=\"variant === 'product' ? 'h3' : 'div'\"\n\t\t\t\t\t\tv-if=\"createNewRoom || rooms.length == 0\"\n\t\t\t\t\t\tclass=\"m-0 text-xl font-bold text-shades-800\"\n\t\t\t\t\t>\n\t\t\t\t\t\tCreate your room\n\t\t\t\t\t</component>\n\t\t\t\t\t<component\n\t\t\t\t\t\t:is=\"variant === 'product' ? 'h3' : 'div'\"\n\t\t\t\t\t\tv-else\n\t\t\t\t\t\tclass=\"m-0 text-xl font-bold text-shades-800\"\n\t\t\t\t\t>\n\t\t\t\t\t\tUpdate your room\n\t\t\t\t\t</component>\n\t\t\t\t</div>\n\n\t\t\t\t<component\n\t\t\t\t\t:is=\"variant === 'product' ? 'h4' : 'div'\"\n\t\t\t\t\tv-if=\"createNewRoom || rooms.length == 0\"\n\t\t\t\t\t:class=\"variant === 'category'\n\t\t\t\t\t\t? 'p-0 m-0 mt-2 text-sm font-normal text-shades-700'\n\t\t\t\t\t\t: 'mt-4 text-sm font-normal text-shades-700'\"\n\t\t\t\t>\n\t\t\t\t\t{{ variant === 'category'\n\t\t\t\t\t\t? 'Please enter your measurements below to create your custom room size.'\n\t\t\t\t\t\t: 'Save your room measurements to see prices across search results and other products.' }}\n\t\t\t\t</component>\n\t\t\t\t<component\n\t\t\t\t\t:is=\"variant === 'product' ? 'h4' : 'div'\"\n\t\t\t\t\tv-else\n\t\t\t\t\t:class=\"variant === 'category'\n\t\t\t\t\t\t? 'mt-3 text-sm font-normal text-shades-700'\n\t\t\t\t\t\t: 'mt-4 text-sm font-normal text-shades-700'\"\n\t\t\t\t>\n\t\t\t\t\tUpdate your existing room.\n\t\t\t\t</component>\n\n\t\t\t\t<div :class=\"variant === 'category' ? 'my-5' : 'mt-[30px] mb-5'\">\n\t\t\t\t\t<div class=\"input-label\">Room name</div>\n\t\t\t\t\t<input\n\t\t\t\t\t\ttype=\"text\"\n\t\t\t\t\t\tv-model=\"roomName\"\n\t\t\t\t\t\tclass=\"w-full input-field\"\n\t\t\t\t\t\tplaceholder=\"Living Room, Dining Room, etc..\"\n\t\t\t\t\t\tmaxlength=\"20\"\n\t\t\t\t\t/>\n\t\t\t\t</div>\n\n\t\t\t\t<div\n\t\t\t\t\t:class=\"variant === 'category'\n\t\t\t\t\t\t? 'flex flex-wrap gap-5 justify-start items-center md:flex-nowrap'\n\t\t\t\t\t\t: 'flex flex-row gap-5 justify-start items-center mb-5'\"\n\t\t\t\t>\n\t\t\t\t\t<div class=\"w-full calc_meaurement-type-block\">\n\t\t\t\t\t\t<div class=\"input-label\">Measurement type</div>\n\t\t\t\t\t\t<div :class=\"variant === 'category' ? 'toggle-wrapper' : 'toggle-wrapper type-toggle-main'\">\n\t\t\t\t\t\t\t<div class=\"toggle-container\" @click=\"toggleInputMode\">\n\t\t\t\t\t\t\t\t<div id=\"areaCheck\" :class=\"{ checked: inputMode === 'total-area' }\">Area</div>\n\t\t\t\t\t\t\t\t<div id=\"dimensionCheck\" :class=\"{ checked: inputMode === 'dimensions' }\">W x L</div>\n\t\t\t\t\t\t\t\t<div class=\"slider\"></div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div v-if=\"inputMode === 'dimensions'\" class=\"w-auto calc_dimension-wrappers\">\n\t\t\t\t\t\t<div :class=\"variant === 'category' ? 'flex w-full' : 'flex space-x-2'\">\n\t\t\t\t\t\t\t<div :class=\"variant === 'category' ? 'w-full basis-1/2 input-wrapper' : 'w-full input-wrapper'\">\n\t\t\t\t\t\t\t\t<div class=\"input-label\">Width</div>\n\t\t\t\t\t\t\t\t<div class=\"relative\">\n\t\t\t\t\t\t\t\t\t<input\n\t\t\t\t\t\t\t\t\t\ttype=\"number\"\n\t\t\t\t\t\t\t\t\t\tmin=\"0\"\n\t\t\t\t\t\t\t\t\t\tmax=\"1000\"\n\t\t\t\t\t\t\t\t\t\tv-model.number=\"width\"\n\t\t\t\t\t\t\t\t\t\tplaceholder=\"E.g. 2\"\n\t\t\t\t\t\t\t\t\t\t:class=\"variant === 'category'\n\t\t\t\t\t\t\t\t\t\t\t? 'input-field calc_measurement-input-block noscroll'\n\t\t\t\t\t\t\t\t\t\t\t: 'w-full input-field noscroll'\"\n\t\t\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t\t\t<span class=\"input-suffix\">{{ METERS }}</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div :class=\"variant === 'category' ? 'w-full basis-1/2 input-wrapper' : 'w-full input-wrapper'\">\n\t\t\t\t\t\t\t\t<div class=\"input-label\">Length</div>\n\t\t\t\t\t\t\t\t<div class=\"relative\">\n\t\t\t\t\t\t\t\t\t<input\n\t\t\t\t\t\t\t\t\t\ttype=\"number\"\n\t\t\t\t\t\t\t\t\t\tmin=\"0\"\n\t\t\t\t\t\t\t\t\t\tmax=\"1000\"\n\t\t\t\t\t\t\t\t\t\tv-model.number=\"length\"\n\t\t\t\t\t\t\t\t\t\tplaceholder=\"E.g. 2\"\n\t\t\t\t\t\t\t\t\t\tclass=\"w-full input-field noscroll\"\n\t\t\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t\t\t<span class=\"input-suffix\">{{ METERS }}</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div v-else :class=\"variant === 'category' ? 'w-full max-w-[180px]' : 'w-full'\">\n\t\t\t\t\t\t<div :class=\"variant === 'category' ? 'flex w-full max-w-[180px]' : ''\">\n\t\t\t\t\t\t\t<div class=\"w-full input-wrapper\">\n\t\t\t\t\t\t\t\t<div class=\"input-label\">Area</div>\n\t\t\t\t\t\t\t\t<div class=\"relative\">\n\t\t\t\t\t\t\t\t\t<input\n\t\t\t\t\t\t\t\t\t\ttype=\"number\"\n\t\t\t\t\t\t\t\t\t\tmin=\"0\"\n\t\t\t\t\t\t\t\t\t\tmax=\"1000\"\n\t\t\t\t\t\t\t\t\t\tv-model.number=\"directArea\"\n\t\t\t\t\t\t\t\t\t\tplaceholder=\"E.g. 2\"\n\t\t\t\t\t\t\t\t\t\tclass=\"w-full input-field noscroll\"\n\t\t\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t\t\t<span class=\"input-suffix\">{{ METERS_SQUARED }}</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Category: save button inline -->\n\t\t\t\t\t<div v-if=\"variant === 'category'\" class=\"room-button-wrapper\">\n\t\t\t\t\t\t<div class=\"hidden input-label md:block\">&nbsp;</div>\n\t\t\t\t\t\t<button @click=\"saveRoomData\" class=\"btn btn-darkGrey btn-icon\">\n\t\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\">\n\t\t\t\t\t\t\t\t<path d=\"M248 72V48H200V72 232H40 16v48H40 200V440v24h48V440 280H408h24V232H408 248V72z\" />\n\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t<span>{{ (createNewRoom || rooms.length == 0) ? \"Save room\" : \"Update room\" }}</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Product: save button below -->\n\t\t\t\t<div v-if=\"variant === 'product'\" class=\"\">\n\t\t\t\t\t<button @click=\"saveRoomData\" class=\"btn btn-darkGrey btn-icon\">\n\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\">\n\t\t\t\t\t\t\t<path d=\"M248 72V48H200V72 232H40 16v48H40 200V440v24h48V440 280H408h24V232H408 248V72z\" />\n\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t<span>{{ (createNewRoom || rooms.length == 0) ? \"Save room\" : \"Update room\" }}</span>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Room list view -->\n\t\t\t<div v-else :class=\"variant === 'category' ? 'p-4 w-full rounded-md bg-shades-50' : 'w-full'\">\n\t\t\t\t<div class=\"text-xl font-bold text-shades-800 leading-none mb-[30px]\">\n\t\t\t\t\tYour rooms\n\t\t\t\t</div>\n\t\t\t\t<div class=\"mb-4\">\n\t\t\t\t\t<div for=\"room-select\" class=\"input-label\">Selected Room</div>\n\t\t\t\t\t<div class=\"input-wrapper\">\n\t\t\t\t\t\t<div :class=\"variant === 'category'\n\t\t\t\t\t\t\t? 'flex flex-wrap items-center space-x-5 md:flex-nowrap'\n\t\t\t\t\t\t\t: 'flex flex-wrap items-center space-x-5 sm:flex-nowrap'\"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<div class=\"select-field-wrapper room-select-field\">\n\t\t\t\t\t\t\t\t<select\n\t\t\t\t\t\t\t\t\tv-model=\"primaryRoomIndex\"\n\t\t\t\t\t\t\t\t\t@change=\"setPrimaryRoom($event.target.value)\"\n\t\t\t\t\t\t\t\t\tid=\"room-select\"\n\t\t\t\t\t\t\t\t\tclass=\"w-full\"\n\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t<option\n\t\t\t\t\t\t\t\t\t\tv-for=\"(room, index) in rooms\"\n\t\t\t\t\t\t\t\t\t\t:key=\"index\"\n\t\t\t\t\t\t\t\t\t\t:value=\"index + 1\"\n\t\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t\t{{ room.roomName }} ({{ room.projectSize }} {{ METERS_SQUARED }})\n\t\t\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div\n\t\t\t\t\t\t\t\tclass=\"font-bold transition-all ease-linear cursor-pointer text-shades-400 hover:text-shades-500\"\n\t\t\t\t\t\t\t\t@click=\"editRoom\"\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\tEdit\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div\n\t\t\t\t\t\t\t\tclass=\"delete-room-button\"\n\t\t\t\t\t\t\t\t:class=\"{ confirm: confirmDelete }\"\n\t\t\t\t\t\t\t\t@click=\"deleteRoom\"\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t{{ confirmDelete ? \"Confirm\" : \"Delete\" }}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div\n\t\t\t\t\t\t\t\tclass=\"delete-room-button cancel\"\n\t\t\t\t\t\t\t\tv-if=\"confirmDelete\"\n\t\t\t\t\t\t\t\t@click=\"confirmDelete = false\"\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\tCancel\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<!-- Product: inline \"+ New\" link -->\n\t\t\t\t\t\t\t<div\n\t\t\t\t\t\t\t\tv-if=\"variant === 'product'\"\n\t\t\t\t\t\t\t\tclass=\"font-bold transition-all ease-linear cursor-pointer text-brand-500 hover:text-brand-600\"\n\t\t\t\t\t\t\t\t@click=\"createNewRoom = true\"\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t+ New\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Category: full \"Create new room\" button -->\n\t\t\t\t<button\n\t\t\t\t\tv-if=\"variant === 'category'\"\n\t\t\t\t\t@click=\"createNewRoom = true\"\n\t\t\t\t\tclass=\"btn btn-darkGrey btn-icon\"\n\t\t\t\t>\n\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\">\n\t\t\t\t\t\t<path d=\"M248 72V48H200V72 232H40 16v48H40 200V440v24h48V440 280H408h24V232H408 248V72z\" />\n\t\t\t\t\t</svg>\n\t\t\t\t\t<span>Create new room</span>\n\t\t\t\t</button>\n\n\t\t\t\t<!-- Login suggestion for guests with rooms -->\n\t\t\t\t<div v-if=\"rooms.length > 0 && !isLoggedIn\" class=\"mt-3 text-sm text-shades-500\">\n\t\t\t\t\t<span class=\"inline-flex gap-1.5 items-center\">\n\t\t\t\t\t\t<svg class=\"flex-shrink-0 w-3.5 h-3.5\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\">\n\t\t\t\t\t\t\t<path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"\n\t\t\t\t\t\t\t\td=\"M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z\"/>\n\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t<span>\n\t\t\t\t\t\t\t<button @click=\"openAuthModal('login')\" class=\"p-0 m-0 text-sm underline bg-transparent border-none cursor-pointer hover:text-shades-700 text-shades-500\">Log in</button>\n\t\t\t\t\t\t\tor\n\t\t\t\t\t\t\t<button @click=\"openAuthModal('register')\" class=\"p-0 m-0 text-sm underline bg-transparent border-none cursor-pointer hover:text-shades-700 text-shades-500\">create an account</button>\n\t\t\t\t\t\t\tto keep your rooms saved\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Slot for additional content (e.g. AreaCalculator on product page) -->\n\t\t\t\t<slot name=\"room-list-extra\"></slot>\n\t\t\t</div>\n\t\t</div>\n\t"
};
module.exports = {
  RoomForm
};

},{"../composables/useRooms.js":11,"../constants.js":12}],8:[function(require,module,exports){
"use strict";

// Import components
var {
  SingleRug
} = require('./SingleRug.js');
var {
  RugCanvas
} = require('./RugCanvas.js');

// Import constants
var {
  formatCurrency
} = require('../../constants.js');
var RugCalculator = {
  name: 'RugCalculator',
  components: {
    SingleRug,
    RugCanvas
  },
  props: {
    postItemToCart: {
      type: Function,
      required: true
    },
    addToCartLoading: {
      type: Boolean,
      required: true
    }
  },
  setup(props) {
    var {
      ref,
      computed,
      onMounted,
      nextTick
    } = Vue;
    var {
      useStore
    } = Vuex;
    var store = useStore();
    var isOpen = ref(false); // Start with dropdown open
    var plannerOpen = ref(false);
    var toggleDropdown = () => {
      isOpen.value = !isOpen.value;
    };
    var selectSize = size => {
      // If it's the same size, just toggle the dropdown
      if (store.state.selectedSize && store.state.selectedSize.rug_ean_code === size.rug_ean_code) {
        toggleDropdown();
        return;
      }

      // Set the size
      store.commit('updateRugSize', size);

      // If open, close it immediately
      if (isOpen.value) {
        isOpen.value = false;
      }
    };

    // Computed property to determine which rugs to display
    var visibleRugs = computed(() => {
      if (isOpen.value) {
        // When open, show all rugs
        return store.state.rugSizes;
      } else if (store.state.selectedSize) {
        // When closed, show only the selected rug
        return store.state.rugSizes.filter(size => size.rug_ean_code === store.state.selectedSize.rug_ean_code);
      }
      // Fallback to all rugs if nothing is selected
      return store.state.rugSizes;
    });
    var lowestPrice = computed(() => {
      return store.state.rugSizes.reduce((min, size) => {
        // Use sale price if available, otherwise use default price
        var effectivePrice = size.rug_sale_price || size.rug_default_price;
        return Math.min(min, effectivePrice);
      }, store.state.rugSizes[0].rug_default_price);
    });
    var selectedSizeText = computed(() => {
      if (!store.state.selectedSize) return '';
      return "".concat(store.state.selectedSize.rug_width, "cm x ").concat(store.state.selectedSize.rug_length, "cm ").concat(store.state.selectedSize.rug_variable_title);
    });
    return {
      store,
      isOpen,
      plannerOpen,
      visibleRugs,
      toggleDropdown,
      selectSize,
      lowestPrice,
      selectedSizeText,
      formatCurrency
    };
  },
  template: "\n        <div class=\"flex items-center justify-between w-full mt-5\">\n            <div class=\"text-sm\">Measurements in</div>\n            <div class=\"text-sm\"></div>\n        </div>\n\n        <div class=\"relative w-full mb-5\">\n            <div @click=\"toggleDropdown\">\n                <div class=\"dropdown-default\" :class=\"{ 'open': isOpen, 'selected': store.state.selectedSize && !isOpen }\">\n                    <div class=\"text-sm font-medium text-shades-800\">\n                        Select a size ({{ store.state.rugSizes.length }} sizes available)\n                    </div>\n                    <div class=\"flex items-center justify-end space-x-2\">\n                        <div class=\"font-bold text-shades-800\">from {{ formatCurrency(lowestPrice) }}</div>\n                        <span class=\"transition-transform duration-300 fill-shades-800\" :class=\"{ 'rotate-180': isOpen }\">\n                            <svg width=\"10\" height=\"10\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\">\n                                <path d=\"M256 82.7l22.6 22.6 192 192L493.3 320 448 365.3l-22.6-22.6L256 173.3 86.6 342.6 64 365.3 18.7 320l22.6-22.6 192-192L256 82.7z\" />\n                            </svg>\n                        </span>\n                    </div>\n                </div>\n            </div>\n            \n            <div v-show=\"isOpen || store.state.selectedSize\" class=\"dropdown-options-container rounded-b-md w-full bg-shades-25 overflow-hidden\">\n                <SingleRug\n                    v-for=\"(size, index) in visibleRugs\"\n                    :key=\"index\"\n                    :size=\"size\"\n                    @click.stop=\"selectSize(size)\"\n                />\n            </div>\n        </div>\n\n        <div class=\"w-full mt-5 mb-5\" v-if=\"store.state.selectedSize\">\n            <div class=\"text-sm font-medium text-shades-800\">\n                Need help finding the right size? Try our rug to room size guide.\n            </div>\n            <div class=\"btn btn-lightGrey w-full md:w-auto\" @click=\"plannerOpen = !plannerOpen\">\n                <span v-if=\"!plannerOpen\">Rug to room size guide</span>\n                <span v-if=\"plannerOpen\">Close</span>\n            </div>\n        </div>\n\n        <div class=\"mt-5 mb-5\" v-if=\"plannerOpen\">\n            <RugCanvas :size=\"store.state.selectedSize\" />\n        </div>\n    "
};

// Export the component using module.exports
module.exports = {
  RugCalculator
};

},{"../../constants.js":12,"./RugCanvas.js":9,"./SingleRug.js":10}],9:[function(require,module,exports){
"use strict";

// Define component
var RugCanvas = {
  name: 'RugCanvas',
  props: {
    size: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    var {
      ref,
      onMounted,
      watch,
      onUnmounted
    } = Vue;
    var canvas = ref(null);
    var ctx = ref(null);
    var roomWidth = ref(null);
    var roomLength = ref(null);
    var gridSize = ref(0.5);
    var dimensionsOverlay = ref(true);
    var roomOffset = ref({
      x: 0,
      y: 0
    });
    var roomPixelSize = ref(0);
    var rug = ref(null);
    var selectedRug = ref(props.size);
    var isDragging = ref(false);
    var dragOffset = ref({
      x: 0,
      y: 0
    });
    var autoAdjusted = ref(false);

    // Utility functions
    var cmToMeters = cm => cm / 100;

    // Function to check if rug fits in current room orientation
    var doesRugFitInRoom = () => {
      if (!rug.value) return true;
      var rugWidthM = cmToMeters(rug.value.width);
      var rugLengthM = cmToMeters(rug.value.length);
      return rugWidthM <= roomWidth.value && rugLengthM <= roomLength.value;
    };

    // Function to check if rug would fit if room was rotated
    var wouldRugFitInRotatedRoom = () => {
      if (!rug.value) return false;
      var rugWidthM = cmToMeters(rug.value.width);
      var rugLengthM = cmToMeters(rug.value.length);
      return rugWidthM <= roomLength.value && rugLengthM <= roomWidth.value;
    };

    // Function to auto-adjust room orientation if needed to fit the rug
    var autoAdjustRoomOrientation = () => {
      if (!rug.value) return;

      // If rug already fits, do nothing
      if (doesRugFitInRoom()) {
        autoAdjusted.value = false;
        return;
      }

      // Check if rug would fit if room was rotated
      if (wouldRugFitInRotatedRoom()) {
        // Rotate the room to fit the rug
        rotateRoom();
        autoAdjusted.value = true;
        return;
      }

      // If we get here, rug won't fit no matter what, so we keep current orientation
      autoAdjusted.value = false;
    };

    // Canvas management functions
    var updateCanvasSize = () => {
      if (!canvas.value) return;
      if (roomWidth.value > 1000) {
        roomWidth.value = 1000;
      }
      if (roomLength.value > 1000) {
        roomLength.value = 1000;
      }

      // Make canvas fill parent width and fixed height
      canvas.value.width = canvas.value.offsetWidth;
      canvas.value.height = 400;

      // Calculate room dimensions while maintaining aspect ratio
      var canvasPadding = 40; // Padding from canvas edges
      var availableWidth = canvas.value.width - canvasPadding * 2;
      var availableHeight = canvas.value.height - canvasPadding * 2;

      // Calculate scale based on room aspect ratio
      var roomAspectRatio = roomLength.value / roomWidth.value;
      if (roomAspectRatio > availableHeight / availableWidth) {
        // Room is taller than wide - fit to height
        roomPixelSize.value = availableHeight / roomAspectRatio;
      } else {
        // Room is wider than tall - fit to width
        roomPixelSize.value = availableWidth;
      }

      // Center the room
      roomOffset.value = {
        x: (canvas.value.width - roomPixelSize.value) / 2,
        y: (canvas.value.height - roomPixelSize.value * roomAspectRatio) / 2
      };
      render();
    };
    var render = () => {
      if (!ctx.value) return;

      // Clear canvas
      ctx.value.clearRect(0, 0, canvas.value.width, canvas.value.height);

      // Draw background
      drawBackground();

      // Draw room
      drawRoom();
      drawGrid();

      // Draw rug if it exists
      if (rug.value) {
        drawRug(rug.value);
      }
    };

    // Drawing functions
    var drawBackground = () => {
      ctx.value.fillStyle = '#F2F4F8'; // Set your desired background color
      ctx.value.fillRect(0, 0, canvas.value.width, canvas.value.height);
    };
    var drawRoom = () => {
      ctx.value.strokeStyle = '#333';
      ctx.value.lineWidth = 2;
      ctx.value.strokeRect(roomOffset.value.x, roomOffset.value.y, roomPixelSize.value, roomPixelSize.value * (roomLength.value / roomWidth.value) // Adjust height based on ratio
      );
    };
    var drawGrid = () => {
      // Set grid size to 0.25 meters
      var gridSize = 0.25;

      // Calculate pixels per meter
      var pixelsPerMeter = roomPixelSize.value / roomWidth.value;
      var gridPixelSize = gridSize * pixelsPerMeter;
      ctx.value.strokeStyle = '#CBD3E4';
      ctx.value.lineWidth = 0.5;

      // Draw vertical lines
      for (var x = 0; x <= roomWidth.value; x += gridSize) {
        var pixelX = roomOffset.value.x + x * pixelsPerMeter;
        ctx.value.beginPath();
        ctx.value.moveTo(pixelX, roomOffset.value.y);
        ctx.value.lineTo(pixelX, roomOffset.value.y + roomPixelSize.value * (roomLength.value / roomWidth.value));
        ctx.value.stroke();
      }

      // Draw horizontal lines
      for (var y = 0; y <= roomLength.value; y += gridSize) {
        var pixelY = roomOffset.value.y + y * pixelsPerMeter;
        ctx.value.beginPath();
        ctx.value.moveTo(roomOffset.value.x, pixelY);
        ctx.value.lineTo(roomOffset.value.x + roomPixelSize.value, pixelY);
        ctx.value.stroke();
      }
    };
    var drawRug = rug => {
      var _props$size;
      // Convert rug centimeters to meters for calculation
      var rugWidthM = cmToMeters(rug.width);
      var rugLengthM = cmToMeters(rug.length);

      // Calculate pixels per meter based on room width
      var pixelsPerMeter = roomPixelSize.value / roomWidth.value;

      // Calculate rug position and dimensions in pixels
      var rugPixelX = roomOffset.value.x + rug.x * pixelsPerMeter;
      var rugPixelY = roomOffset.value.y + rug.y * pixelsPerMeter;
      var rugPixelWidth = rugWidthM * pixelsPerMeter;
      var rugPixelHeight = rugLengthM * pixelsPerMeter;
      ctx.value.fillStyle = rug.color;
      switch ((_props$size = props.size) === null || _props$size === void 0 ? void 0 : _props$size.rug_shape) {
        case 'circle':
          // Draw circle
          ctx.value.beginPath();
          ctx.value.ellipse(rugPixelX + rugPixelWidth / 2,
          // center X
          rugPixelY + rugPixelHeight / 2,
          // center Y
          rugPixelWidth / 2,
          // radiusX
          rugPixelHeight / 2,
          // radiusY
          0,
          // rotation
          0,
          // startAngle
          2 * Math.PI // endAngle
          );
          ctx.value.fill();

          // Draw selection border if selected
          if (rug === selectedRug.value) {
            ctx.value.strokeStyle = '#000';
            ctx.value.lineWidth = 2;
            ctx.value.stroke();
          }
          break;
        case 'square':
        case 'rectangle':
        default:
          // Draw rectangle
          ctx.value.fillRect(rugPixelX, rugPixelY, rugPixelWidth, rugPixelHeight);

          // Draw selection border if selected
          if (rug === selectedRug.value) {
            ctx.value.strokeStyle = '#000';
            ctx.value.lineWidth = 2;
            ctx.value.strokeRect(rugPixelX, rugPixelY, rugPixelWidth, rugPixelHeight);
          }
          break;
      }
    };

    // Rug management functions
    var addRug = (width, length) => {
      console.log('Adding rug:', width, length);
      var rugWidthM = cmToMeters(width);
      var rugLengthM = cmToMeters(length);

      // Create the rug first
      rug.value = {
        x: 0,
        y: 0,
        width: width,
        length: length,
        color: "rgba(100, 100, 100, 0.7)"
      };

      // Auto-adjust room orientation if needed
      autoAdjustRoomOrientation();

      // Always center the rug
      var centerX = Math.max(0, (roomWidth.value - rugWidthM) / 2);
      var centerY = Math.max(0, (roomLength.value - rugLengthM) / 2);
      rug.value.x = centerX;
      rug.value.y = centerY;
      render();
    };
    var rotateRug = () => {
      if (!rug.value) return;

      // Swap rug dimensions
      var tempWidth = rug.value.width;
      rug.value.width = rug.value.length;
      rug.value.length = tempWidth;

      // Auto-adjust room orientation if needed for the rotated rug
      autoAdjustRoomOrientation();

      // Re-center rug with new dimensions
      addRug(rug.value.width, rug.value.length);
    };
    var rotateRoom = () => {
      // Swap room dimensions
      var tempWidth = roomWidth.value;
      roomWidth.value = roomLength.value;
      roomLength.value = tempWidth;

      // Update canvas with new dimensions
      updateCanvasSize();

      // Re-center rug if it exists
      if (rug.value) {
        // Calculate center point first (to preserve position)
        var rugWidthM = cmToMeters(rug.value.width);
        var rugLengthM = cmToMeters(rug.value.length);

        // Always center the rug
        var centerX = Math.max(0, (roomWidth.value - rugWidthM) / 2);
        var centerY = Math.max(0, (roomLength.value - rugLengthM) / 2);
        rug.value.x = centerX;
        rug.value.y = centerY;
        render();
      }
    };

    // Mouse event handlers
    var getMousePos = e => {
      var rect = canvas.value.getBoundingClientRect();
      var mouseX = e.clientX - rect.left;
      var mouseY = e.clientY - rect.top;
      return {
        x: (mouseX - roomOffset.value.x) / roomPixelSize.value * roomWidth.value,
        y: (mouseY - roomOffset.value.y) / (roomPixelSize.value * (roomLength.value / roomWidth.value)) * roomLength.value
      };
    };
    var handleMouseDown = e => {
      var pos = getMousePos(e);
      if (rug.value) {
        var rugWidthM = cmToMeters(rug.value.width);
        var rugLengthM = cmToMeters(rug.value.length);

        // Calculate rug bounds in room coordinates
        var rugBounds = {
          left: rug.value.x,
          right: rug.value.x + rugWidthM,
          top: rug.value.y,
          bottom: rug.value.y + rugLengthM
        };

        // Check if click is within rug bounds
        if (pos.x >= rugBounds.left && pos.x <= rugBounds.right && pos.y >= rugBounds.top && pos.y <= rugBounds.bottom) {
          selectedRug.value = rug.value;
          isDragging.value = true;
          dragOffset.value = {
            x: pos.x - rug.value.x,
            y: pos.y - rug.value.y
          };
        }
      }
    };
    var handleMouseMove = e => {
      if (!isDragging.value || !selectedRug.value) return;
      var pos = getMousePos(e);
      var rugWidthM = cmToMeters(selectedRug.value.width);
      var rugLengthM = cmToMeters(selectedRug.value.length);
      rug.value.x = pos.x - dragOffset.value.x;
      rug.value.y = pos.y - dragOffset.value.y;

      // Keep rug within room bounds
      rug.value.x = Math.max(0, Math.min(rug.value.x, roomWidth.value - rugWidthM));
      rug.value.y = Math.max(0, Math.min(rug.value.y, roomLength.value - rugLengthM));
      render();
    };
    var handleMouseUp = () => {
      isDragging.value = false;
    };
    var updateCursor = e => {
      var pos = getMousePos(e);
      if (rug.value) {
        var rugWidthM = cmToMeters(rug.value.width);
        var rugLengthM = cmToMeters(rug.value.length);
        if (pos.x >= rug.value.x && pos.x <= rug.value.x + rugWidthM && pos.y >= rug.value.y && pos.y <= rug.value.y + rugLengthM) {
          canvas.value.style.cursor = 'move';
          return;
        }
      }
      canvas.value.style.cursor = 'default';
    };

    // Add function to confirm dimensions
    var confirmDimensions = () => {
      dimensionsOverlay.value = false;
      updateCanvasSize();

      // After confirming dimensions, auto-adjust room orientation if needed
      if (rug.value) {
        autoAdjustRoomOrientation();
        // Re-center rug with new dimensions
        addRug(rug.value.width, rug.value.length);
      }
      render();
    };

    // Lifecycle hooks and watchers
    onMounted(() => {
      ctx.value = canvas.value.getContext('2d');
      updateCanvasSize();
      window.addEventListener('resize', updateCanvasSize);
      canvas.value.addEventListener('mousemove', updateCursor);
    });
    onUnmounted(() => {
      window.removeEventListener('resize', updateCanvasSize);
      if (canvas.value) {
        canvas.value.removeEventListener('mousemove', updateCursor);
      }
    });

    // Watchers
    watch(() => props.size, newSize => {
      if (newSize) {
        addRug(newSize.rug_width, newSize.rug_length);
      }
    }, {
      immediate: true
    });
    watch([roomWidth, roomLength], () => {
      if (rug.value) {
        // Auto-adjust room orientation if needed after room size changes
        autoAdjustRoomOrientation();
        addRug(rug.value.width, rug.value.length);
      }
      render();
    });
    watch(() => {
      var _canvas$value;
      return (_canvas$value = canvas.value) === null || _canvas$value === void 0 ? void 0 : _canvas$value.offsetWidth;
    }, () => updateCanvasSize(), {
      immediate: true
    });
    return {
      canvas,
      roomWidth,
      roomLength,
      dimensionsOverlay,
      rug,
      handleMouseDown,
      handleMouseMove,
      handleMouseUp,
      rotateRug,
      rotateRoom,
      cmToMeters,
      confirmDimensions,
      autoAdjusted
    };
  },
  template: "\n        <div class=\"room-planner-container\">\n            <div class=\"relative\">\n                <canvas ref=\"canvas\" class=\"w-full h-[400px]\" \n                    @mousedown=\"handleMouseDown\" \n                    @mousemove=\"handleMouseMove\"\n                    @mouseup=\"handleMouseUp\" \n                    @contextmenu.prevent>\n                </canvas>\n                <div v-if=\"roomWidth && roomLength && rug && (roomWidth < cmToMeters(rug.width) || roomLength < cmToMeters(rug.length))\"\n                    class=\"rug-warning\">Warning: Rug exceeds the dimensions of the room</div>\n                <div v-if=\"autoAdjusted\" class=\"auto-adjusted-notice\">Room orientation was adjusted to fit the rug</div>\n                <div v-if=\"dimensionsOverlay\" class=\"dimensions-overlay\">\n                    <div class=\"dimensions-overlay-content\">\n                        <div class=\"mb-2 font-medium text-shades-800\">Enter the dimensions of the room:</div>\n                        <div class=\"text-sm text-shades-800\">Room Width</div>\n                        <input class=\"w-full mb-2 input-field\" type=\"number\" placeholder=\"Room Width\" v-model=\"roomWidth\"\n                            @change=\"render\">\n                        <div class=\"text-sm text-shades-800\">Room Length</div>\n                        <input class=\"w-full mb-2 input-field\" type=\"number\" placeholder=\"Room Length\" v-model=\"roomLength\"\n                            @change=\"render\">\n                        <button class=\"w-full btn btn-primary\" @click=\"confirmDimensions\">Confirm</button>\n                    </div>\n                </div>\n            </div>\n            <div class=\"grid grid-cols-1 md:grid-cols-3 gap-2 p-2 bg-shades-50\">\n                <button @click=\"rotateRug\" class=\"btn btn-primary btn-icon\">\n                    <svg width=\"15\" height=\"15\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\">\n                        <path\n                            d=\"M142.9 142.9c-17.5 17.5-30.1 38-37.8 59.8L44.8 181.4C55.6 150.7 73.2 122 97.6 97.6c87.5-87.5 229.3-87.5 316.8 0c0 0 0 0 0 0L472 40l24 24 0 160-160 0-24-24 57.1-57.1s0 0 0 0c-62.5-62.5-163.8-62.5-226.3 0zm0 226.3c62.5 62.5 163.8 62.5 226.3 0c17.5-17.5 30.1-38 37.8-59.8l60.4 21.3c-10.8 30.6-28.4 59.3-52.9 83.8c-87.5 87.5-229.3 87.5-316.7 0c0 0 0 0 0 0L40 472 16 448l0-160 160 0 24 24-57.1 57.1z\" />\n                    </svg>\n                    <div>Rug</div>\n                </button>\n                <button @click=\"rotateRoom\" class=\"btn btn-primary btn-icon\">\n                    <svg width=\"15\" height=\"15\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\">\n                        <path\n                            d=\"M142.9 142.9c-17.5 17.5-30.1 38-37.8 59.8L44.8 181.4C55.6 150.7 73.2 122 97.6 97.6c87.5-87.5 229.3-87.5 316.8 0c0 0 0 0 0 0L472 40l24 24 0 160-160 0-24-24 57.1-57.1s0 0 0 0c-62.5-62.5-163.8-62.5-226.3 0zm0 226.3c62.5 62.5 163.8 62.5 226.3 0c17.5-17.5 30.1-38 37.8-59.8l60.4 21.3c-10.8 30.6-28.4 59.3-52.9 83.8c-87.5 87.5-229.3 87.5-316.7 0c0 0 0 0 0 0L40 472 16 448l0-160 160 0 24 24-57.1 57.1z\" />\n                    </svg>\n                    <div>Room</div>\n                </button>\n                <button @click=\"dimensionsOverlay = true\" class=\"btn btn-primary btn-icon\">\n                    <svg width=\"15\" height=\"15\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\">\n                        <path\n                            d=\"M142.9 142.9c-17.5 17.5-30.1 38-37.8 59.8L44.8 181.4C55.6 150.7 73.2 122 97.6 97.6c87.5-87.5 229.3-87.5 316.8 0c0 0 0 0 0 0L472 40l24 24 0 160-160 0-24-24 57.1-57.1s0 0 0 0c-62.5-62.5-163.8-62.5-226.3 0zm0 226.3c62.5 62.5 163.8 62.5 226.3 0c17.5-17.5 30.1-38 37.8-59.8l60.4 21.3c-10.8 30.6-28.4 59.3-52.9 83.8c-87.5 87.5-229.3 87.5-316.7 0c0 0 0 0 0 0L40 472 16 448l0-160 160 0 24 24-57.1 57.1z\" />\n                    </svg>\n                    <div>Edit Dimensions</div>\n                </button>\n            </div>\n        </div>\n    "
};

// Export the component using module.exports
module.exports = {
  RugCanvas
};

},{}],10:[function(require,module,exports){
"use strict";

// Import constants
var {
  formatCurrency
} = require('../../constants.js');

// Define component
var SingleRug = {
  name: 'SingleRug',
  props: {
    size: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    var {
      computed
    } = Vue;
    var {
      useStore
    } = Vuex;
    var store = useStore();
    return {
      store,
      formatCurrency
    };
  },
  template: "\n        <div class=\"single-size-option\" :class=\"{                           \n                'bg-shades-100': size.rug_sku === store.state.selectedSize?.rug_sku\n            }\">\n            <div> \n                <div class=\"mb-1 text-sm font-bold leading-none text-shades-800\">\n                    {{ size.rug_width }}cm x {{ size.rug_length }}cm {{ size.rug_variable_title }}\n                </div>\n                <div class=\"mb-1 text-xs text-brand-600\" v-if=\"size.rug_stock <= 3\">\n                    Hurry only {{ size.rug_stock }} remaining\n                </div>\n                <div class=\"single-option-delivery\">\n                    <svg class=\"fill-shades-600\" xmlns=\"http://www.w3.org/2000/svg\" width=\"10\" height=\"10\" viewBox=\"0 0 640 512\">\n                        <path d=\"M640 0l0 400c0 61.9-50.1 112-112 112c-61.6 0-111.6-49.8-112-111.3L48.6 502.8l-30.8 8.6L.6 449.7l30.8-8.6L352 352.1 352 0 640 0zM576 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM14.8 176.8l77.3-20.7 24.8 92.7 61.8-16.6-24.8-92.7 77.3-20.7 58 216.4-216.4 58-58-216.4z\" />\n                    </svg>\n                    <span>Free Delivery from 24th February</span>\n                </div>\n            </div>\n            <div class=\"text-right\">\n                <div class=\"font-semibold text-brand-500\">\n                    {{ formatCurrency(size.rug_sale_price || size.rug_default_price) }}\n                </div>\n                <div v-if=\"size.rug_sale_price\" class=\"text-sm line-through text-shades-500\">\n                    {{ formatCurrency(size.rug_default_price) }}\n                </div>\n            </div>\n        </div>\n    "
};

// Export the component using module.exports
module.exports = {
  SingleRug
};

},{"../../constants.js":12}],11:[function(require,module,exports){
"use strict";

require("core-js/modules/es.promise.js");
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var {
  migrateRoomsToMeters
} = require('../constants.js');

/**
 * Composable for shared room management logic.
 * Used by RoomForm component on both product and category pages.
 *
 * @param {Object} options
 * @param {Function} [options.onRoomsChanged] - Called after room data changes (save, delete, primary change)
 * @param {Function} [options.onRoomDeleted] - Called when a room is deleted, receives { deletedIndex }
 */
function useRooms() {
  var _window$fkCalculatorD;
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var {
    ref,
    watch,
    nextTick
  } = Vue;
  var {
    onRoomsChanged = null,
    onRoomDeleted = null
  } = options;

  // State refs
  var roomName = ref('');
  var width = ref('');
  var length = ref('');
  var directArea = ref('');
  var unitType = ref('m2');
  var rooms = ref([]);
  var inputMode = ref('dimensions');
  var createNewRoom = ref(false);
  var modifyRoom = ref(false);
  var primaryRoomIndex = ref(1);
  var confirmDelete = ref(false);
  var maxAreaMeters = ref(10000);
  var isLoggedIn = ref(((_window$fkCalculatorD = window.fkCalculatorData) === null || _window$fkCalculatorD === void 0 ? void 0 : _window$fkCalculatorD.isLoggedIn) || false);
  var isSaving = ref(false);

  // Auto-show create form when rooms are empty
  watch(rooms, newRooms => {
    if (newRooms.length === 0) {
      createNewRoom.value = true;
    }
  }, {
    deep: true
  });
  var calculateProjectSize = () => {
    if (directArea.value && inputMode.value === 'total-area') {
      return directArea.value;
    }
    if (!width.value || !length.value) {
      return null;
    }
    return (width.value * length.value).toFixed(2);
  };
  var resetForm = () => {
    roomName.value = '';
    width.value = '';
    length.value = '';
    directArea.value = '';
    createNewRoom.value = false;
    modifyRoom.value = false;
  };
  var saveRoomData = () => {
    // Validate room name
    if (!roomName.value || roomName.value.length === 0) return false;

    // Validate numeric inputs based on input mode
    if (inputMode.value === 'dimensions') {
      if (!Number.isFinite(width.value) || width.value <= 0) return false;
      if (!Number.isFinite(length.value) || length.value <= 0) return false;
    }
    if (inputMode.value === 'total-area') {
      if (!Number.isFinite(directArea.value) || directArea.value <= 0) return false;
    }
    var projectSize = calculateProjectSize();
    if (projectSize > maxAreaMeters.value) {
      projectSize = maxAreaMeters.value;
    }
    var newRoom = {
      roomName: roomName.value,
      inputMode: inputMode.value,
      projectSize: projectSize,
      width: width.value,
      length: length.value,
      unitType: 'm2'
    };
    var existingRoomIndex = rooms.value.findIndex(room => room.roomName === roomName.value);
    if (existingRoomIndex !== -1 && createNewRoom.value) {
      return false;
    } else if (modifyRoom.value) {
      rooms.value[primaryRoomIndex.value - 1] = newRoom;
    } else {
      rooms.value.push(newRoom);
      setPrimaryRoom(rooms.value.length);
    }

    // Save rooms - to server for logged-in users, to cookie for guests
    if (isLoggedIn.value) {
      saveRoomsToServer();
    } else {
      Cookies.set('roomsData', JSON.stringify(rooms.value), {
        expires: 7
      });
    }
    if (rooms.value.length === 1) {
      setPrimaryRoom(1);
    }
    onRoomsChanged === null || onRoomsChanged === void 0 || onRoomsChanged();
    resetForm();
    return true;
  };
  var editRoom = () => {
    var existingRoomIndex = rooms.value.findIndex(room => room.roomName === rooms.value[primaryRoomIndex.value - 1].roomName);
    if (existingRoomIndex !== -1) {
      modifyRoom.value = true;
      roomName.value = rooms.value[existingRoomIndex].roomName;
      unitType.value = rooms.value[existingRoomIndex].unitType;
      inputMode.value = rooms.value[existingRoomIndex].inputMode;
      length.value = rooms.value[existingRoomIndex].length;
      width.value = rooms.value[existingRoomIndex].width;
      directArea.value = rooms.value[existingRoomIndex].projectSize;
    }
  };
  var deleteRoom = () => {
    if (!confirmDelete.value) {
      confirmDelete.value = true;
      return;
    } else {
      confirmDelete.value = false;
    }
    if (primaryRoomIndex.value > 0 && primaryRoomIndex.value <= rooms.value.length) {
      var deletedIndex = primaryRoomIndex.value;
      rooms.value.splice(primaryRoomIndex.value - 1, 1);
      primaryRoomIndex.value = 1;
      onRoomDeleted === null || onRoomDeleted === void 0 || onRoomDeleted({
        deletedIndex
      });
      onRoomsChanged === null || onRoomsChanged === void 0 || onRoomsChanged();

      // Save rooms - to server for logged-in users, to cookie for guests
      if (isLoggedIn.value) {
        saveRoomsToServer();
      } else {
        Cookies.set('roomsData', JSON.stringify(rooms.value), {
          expires: 7
        });
        Cookies.set('primaryRoomIndex', primaryRoomIndex.value, {
          expires: 7
        });
      }
    }
  };
  var loadRooms = () => {
    if (isLoggedIn.value) {
      var _window$fkCalculatorD2, _window$fkCalculatorD3;
      rooms.value = ((_window$fkCalculatorD2 = window.fkCalculatorData) === null || _window$fkCalculatorD2 === void 0 ? void 0 : _window$fkCalculatorD2.rooms) || [];
      primaryRoomIndex.value = ((_window$fkCalculatorD3 = window.fkCalculatorData) === null || _window$fkCalculatorD3 === void 0 ? void 0 : _window$fkCalculatorD3.primaryRoomIndex) || 1;
      if (rooms.value.length > 0 && (isNaN(primaryRoomIndex.value) || primaryRoomIndex.value > rooms.value.length)) {
        primaryRoomIndex.value = 1;
      }
    } else {
      var roomsData = Cookies.get('roomsData');
      if (roomsData) {
        var parsedRooms;
        try {
          parsedRooms = JSON.parse(roomsData);
        } catch (e) {
          console.warn('Invalid roomsData cookie; clearing.', e);
          Cookies.remove('roomsData');
          return;
        }
        var {
          rooms: migratedRooms,
          migrated
        } = migrateRoomsToMeters(parsedRooms);
        rooms.value = migratedRooms;
        if (migrated) {
          Cookies.set('roomsData', JSON.stringify(migratedRooms), {
            expires: 7
          });
        }
        var primaryRoomIndexCookie = Cookies.get('primaryRoomIndex');
        if (primaryRoomIndexCookie !== null && primaryRoomIndexCookie !== '') {
          primaryRoomIndex.value = parseInt(primaryRoomIndexCookie);
        }
        if (rooms.value.length > 0 && (isNaN(primaryRoomIndex.value) || primaryRoomIndex.value > rooms.value.length)) {
          primaryRoomIndex.value = 1;
          setPrimaryRoomLocal(1);
        }
      }
    }
  };
  var saveRoomsToServer = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* () {
      if (!isLoggedIn.value || isSaving.value) return;
      isSaving.value = true;
      try {
        var formData = new FormData();
        formData.append('action', 'fk_save_rooms');
        formData.append('nonce', window.fkCalculatorData.nonce);
        formData.append('rooms', JSON.stringify(rooms.value));
        formData.append('primaryIndex', primaryRoomIndex.value);
        var response = yield fetch(window.fkCalculatorData.ajaxUrl, {
          method: 'POST',
          body: formData
        });
        if (!response.ok) {
          throw new Error('Failed to save rooms (' + response.status + ')');
        }
      } catch (error) {
        console.error('Error saving rooms to server:', error);
      } finally {
        isSaving.value = false;
      }
    });
    return function saveRoomsToServer() {
      return _ref.apply(this, arguments);
    };
  }();
  var setPrimaryRoomOnServer = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (index) {
      if (!isLoggedIn.value) return;
      try {
        var formData = new FormData();
        formData.append('action', 'fk_set_primary_room');
        formData.append('nonce', window.fkCalculatorData.nonce);
        formData.append('primaryIndex', index);
        var response = yield fetch(window.fkCalculatorData.ajaxUrl, {
          method: 'POST',
          body: formData
        });
        if (!response.ok) {
          throw new Error('Failed to set primary room (' + response.status + ')');
        }
      } catch (error) {
        console.error('Error setting primary room on server:', error);
      }
    });
    return function setPrimaryRoomOnServer(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var setPrimaryRoomLocal = index => {
    primaryRoomIndex.value = parseInt(index);
    Cookies.set('primaryRoomIndex', primaryRoomIndex.value, {
      expires: 7
    });
  };
  var openAuthModal = mode => {
    window.dispatchEvent(new CustomEvent('open-auth-modal', {
      detail: {
        mode
      }
    }));
  };
  var setPrimaryRoom = index => {
    primaryRoomIndex.value = parseInt(index);
    if (isLoggedIn.value) {
      setPrimaryRoomOnServer(index);
    } else {
      Cookies.set('primaryRoomIndex', primaryRoomIndex.value, {
        expires: 7
      });
    }
  };
  var toggleInputMode = () => {
    inputMode.value = inputMode.value === 'dimensions' ? 'total-area' : 'dimensions';
    if (directArea.value != calculateProjectSize()) {
      nextTick(() => {
        width.value = '';
        length.value = '';
      });
    }
  };
  return {
    // State
    roomName,
    width,
    length,
    directArea,
    unitType,
    rooms,
    inputMode,
    createNewRoom,
    modifyRoom,
    primaryRoomIndex,
    confirmDelete,
    maxAreaMeters,
    isLoggedIn,
    isSaving,
    // Methods
    calculateProjectSize,
    loadRooms,
    saveRoomData,
    editRoom,
    deleteRoom,
    resetForm,
    setPrimaryRoom,
    toggleInputMode,
    openAuthModal,
    saveRoomsToServer
  };
}
module.exports = {
  useRooms
};

},{"../constants.js":12,"core-js/modules/es.promise.js":138}],12:[function(require,module,exports){
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var METERS_SQUARED = 'm²';
var METERS = 'm';

// Conversion constants kept for migrating legacy feet data to meters
var SQUARE_FEET_TO_METERS = 1 / 10.764;
var FEET_TO_METERS = 1 / 3.281;
var formatCurrency = function (value) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-GB';
  var currency = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GBP';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency
  }).format(value);
};

/**
 * Migrate legacy room data from feet to meters
 * @param {Array} rooms - Array of room objects
 * @returns {Array} - Rooms with ft2 converted to m2
 */
var migrateRoomsToMeters = rooms => {
  if (!Array.isArray(rooms)) return rooms;
  var migrated = false;
  var migratedRooms = rooms.map(room => {
    if (room.unitType === 'ft2') {
      migrated = true;
      return _objectSpread(_objectSpread({}, room), {}, {
        projectSize: Number((room.projectSize * SQUARE_FEET_TO_METERS).toFixed(2)),
        width: room.width ? Number((room.width * FEET_TO_METERS).toFixed(2)) : room.width,
        length: room.length ? Number((room.length * FEET_TO_METERS).toFixed(2)) : room.length,
        unitType: 'm2'
      });
    }
    return room;
  });
  return {
    rooms: migratedRooms,
    migrated
  };
};
module.exports = {
  METERS_SQUARED,
  METERS,
  SQUARE_FEET_TO_METERS,
  FEET_TO_METERS,
  formatCurrency,
  migrateRoomsToMeters
};

},{}],13:[function(require,module,exports){
"use strict";

require("core-js/modules/web.dom-collections.iterator.js");
var _vueAppData$product;
// Import components
var {
  ProductCalculator
} = require("./components/ProductCalculator.js");
var {
  METERS_SQUARED,
  METERS,
  formatCurrency
} = require("./constants.js");
var vueProduct = (_vueAppData$product = vueAppData.product) !== null && _vueAppData$product !== void 0 ? _vueAppData$product : null;
var getProductType = () => {
  if (vueProduct !== null && vueProduct !== void 0 && vueProduct.packSize) {
    return "pack";
  } else if (vueProduct !== null && vueProduct !== void 0 && vueProduct.rollWidths) {
    return "roll";
  } else if (vueProduct.productType == "Rug") {
    return vueProduct.productType;
  }
  return "accessory";
};
function createProductStore() {
  var {
    createStore
  } = Vuex;
  return createStore({
    state() {
      var _vueProduct$rollWidth, _vueProduct$bulkTiers, _vueProduct$underlayP, _vueProduct$adhesiveP, _vueProduct$weldrodPr, _vueProduct$weldrodOp, _vueProduct$freeUpsel, _vueProduct$rugSizes;
      return {
        /* static data */
        productId: vueProduct === null || vueProduct === void 0 ? void 0 : vueProduct.productId,
        defaultPrice: Number(vueProduct === null || vueProduct === void 0 ? void 0 : vueProduct.productPrice),
        defaultRegularPrice: Number(vueProduct === null || vueProduct === void 0 ? void 0 : vueProduct.productRegularPrice),
        packSize: vueProduct !== null && vueProduct !== void 0 && vueProduct.packSize ? Number(vueProduct === null || vueProduct === void 0 ? void 0 : vueProduct.packSize) : null,
        rollWidths: (_vueProduct$rollWidth = vueProduct === null || vueProduct === void 0 ? void 0 : vueProduct.rollWidths) !== null && _vueProduct$rollWidth !== void 0 ? _vueProduct$rollWidth : null,
        bulkTiers: (_vueProduct$bulkTiers = vueProduct === null || vueProduct === void 0 ? void 0 : vueProduct.bulkTiers) !== null && _vueProduct$bulkTiers !== void 0 ? _vueProduct$bulkTiers : null,
        bulkDiscountPrice: vueProduct === null || vueProduct === void 0 ? void 0 : vueProduct.bulkDiscountPrice,
        bulkOrderThreshold: vueProduct === null || vueProduct === void 0 ? void 0 : vueProduct.bulkOrderThreshold,
        productName: vueProduct === null || vueProduct === void 0 ? void 0 : vueProduct.name,
        productType: getProductType(),
        underlayProducts: (_vueProduct$underlayP = vueProduct === null || vueProduct === void 0 ? void 0 : vueProduct.underlayProducts) !== null && _vueProduct$underlayP !== void 0 ? _vueProduct$underlayP : null,
        adhesiveProducts: (_vueProduct$adhesiveP = vueProduct === null || vueProduct === void 0 ? void 0 : vueProduct.adhesiveProducts) !== null && _vueProduct$adhesiveP !== void 0 ? _vueProduct$adhesiveP : null,
        weldrodProducts: (_vueProduct$weldrodPr = vueProduct === null || vueProduct === void 0 ? void 0 : vueProduct.weldrodProducts) !== null && _vueProduct$weldrodPr !== void 0 ? _vueProduct$weldrodPr : null,
        weldrodOptions: (_vueProduct$weldrodOp = vueProduct === null || vueProduct === void 0 ? void 0 : vueProduct.weldrodOptions) !== null && _vueProduct$weldrodOp !== void 0 ? _vueProduct$weldrodOp : null,
        freeUpsells: (_vueProduct$freeUpsel = vueProduct === null || vueProduct === void 0 ? void 0 : vueProduct.freeUpsells) !== null && _vueProduct$freeUpsel !== void 0 ? _vueProduct$freeUpsel : null,
        roomsEnabled: vueProduct === null || vueProduct === void 0 ? void 0 : vueProduct.roomsEnabled,
        backingEnabled: vueProduct === null || vueProduct === void 0 ? void 0 : vueProduct.backingEnabled,
        hybridEnabled: vueProduct === null || vueProduct === void 0 ? void 0 : vueProduct.hybridEnabled,
        maxAreaMeters: 50000,
        accessoryDescriptionName: vueProduct === null || vueProduct === void 0 ? void 0 : vueProduct.accessory_description_name,
        rugSizes: (_vueProduct$rugSizes = vueProduct === null || vueProduct === void 0 ? void 0 : vueProduct.rugSizes) !== null && _vueProduct$rugSizes !== void 0 ? _vueProduct$rugSizes : null,
        selectedSize: null,
        /* variable data */
        area: null,
        width: null,
        length: null,
        quantity: null,
        unit: "m2",
        recommendedWastage: false,
        accessories: [],
        cart: vueAppData.cart
      };
    },
    mutations: {
      setArea(state, area) {
        if (area > state.maxAreaMeters) {
          area = state.maxAreaMeters;
        }
        state.area = area;
      },
      setLength(state, length) {
        state.length = length;
      },
      setWidth(state, width) {
        state.width = width;
      },
      setUnit(state, unit) {
        state.unit = unit;
      },
      setPacks(state, packs) {
        state.packs = packs;
      },
      addAccessories(state, accessories) {
        accessories.forEach(newAccessory => {
          if (newAccessory.quantity == 0) return;
          if (newAccessory.accessories_type === "Underlay") {
            state.accessories = state.accessories.filter(acc => acc.accessories_type !== "Underlay");
          }
          var existingAccessory = state.accessories.find(accessory => accessory.id === newAccessory.id);
          if (existingAccessory) {
            existingAccessory.quantity = newAccessory.quantity;
          } else {
            state.accessories.push(newAccessory);
          }
        });
      },
      updateAccessory(state, _ref) {
        var {
          index,
          quantity
        } = _ref;
        var accessories = state.accessories;
        accessories[index].quantity = quantity;
      },
      removeAccessory(state, index) {
        state.accessories.splice(index, 1);
      },
      setQuantity(state, quantity) {
        state.quantity = quantity;
      },
      updateRugSize(state, size) {
        state.selectedSize = size;
      }
    },
    actions: {
      setUnit(_ref2, unit) {
        var {
          commit
        } = _ref2;
        commit("setUnit", unit);
      },
      setArea(_ref3, area) {
        var {
          commit
        } = _ref3;
        commit("setArea", area);
      },
      setLength(_ref4, length) {
        var {
          commit
        } = _ref4;
        commit("setLength", length);
      },
      setWidth(_ref5, width) {
        var {
          commit
        } = _ref5;
        commit("setWidth", width);
      },
      addAccessories(_ref6, accessories) {
        var {
          commit
        } = _ref6;
        commit("addAccessories", accessories);
      },
      removeAccessory(_ref7, index) {
        var {
          commit
        } = _ref7;
        commit("removeAccessory", index);
      },
      updateAccessory(_ref8, data) {
        var {
          commit
        } = _ref8;
        if (data.quantity <= 0) {
          return commit("removeAccessory", data.index);
        }
        commit("updateAccessory", data);
      },
      setPacks(_ref9, packs) {
        var {
          commit,
          state
        } = _ref9;
        var area = packs * state.packSize;
        if (state.recommendedWastage) {
          area = area - Number(area * 0.1);
        }
        if (area != 0) {
          area -= 0.02;
        }
        commit("setArea", area.toFixed(2));
        commit("setPacks", packs);
      },
      setQuantity(_ref10, quantity) {
        var {
          commit
        } = _ref10;
        commit("setQuantity", quantity);
      },
      resetPacks(_ref11) {
        var {
          commit
        } = _ref11;
        commit("setPacks", null);
      }
    },
    getters: {
      unitText: () => {
        return METERS;
      },
      unitSquaredText: () => {
        return METERS_SQUARED;
      },
      packsNeeded: (state, getters) => {
        if (state.quantity) {
          return state.quantity;
        }
        return Math.ceil(getters.computedArea / state.packSize);
      },
      computedArea: state => {
        var area = 0;
        if (state.area) {
          area = state.area < 0 ? -Number(state.area) : Number(state.area);
        } else if (state.productType === "roll" && state.width != null && state.length != null) {
          // Carpet/roll: derive area from width × length when area not yet set
          var w = Number(state.width);
          var l = Number(state.length);
          if (w > 0 && l > 0) area = w * l;
        }
        if (area > 0 && state.recommendedWastage) {
          area += Number(area * 0.1);
        }
        return area;
      },
      totalComputedArea: (state, getters) => {
        var area = 0;
        if (state.productType == "pack") {
          area = getters.packsNeeded * state.packSize;
        } else if (state.productType == "roll") {
          area = getters.computedArea;
        }
        return area || 0; // Ensure we always return a number
      },
      showWastageOption: (state, getters) => {
        if (state.productType !== "pack" || !state.area || state.area <= 0) {
          return false;
        }
        var orderedArea = getters.totalComputedArea;
        var requiredArea = Number(state.area);
        var effectiveWastage = (orderedArea - requiredArea) / requiredArea;
        return effectiveWastage < 0.1;
      },
      hasBuiltInWastage: (state, getters) => {
        if (state.productType !== "pack" || !state.area || state.area <= 0) {
          return false;
        }
        var orderedArea = getters.totalComputedArea;
        var requiredArea = Number(state.area);
        var effectiveWastage = (orderedArea - requiredArea) / requiredArea;
        return effectiveWastage >= 0.1;
      },
      isDiscounted: (state, getters) => {
        return getters.productPrice !== state.defaultPrice;
      },
      productPrice: (state, getters) => {
        var price = state.defaultPrice;
        var appliedTierIndex = -1;
        var allTiers = document.querySelectorAll("div[data-tier-index]");
        allTiers.forEach(tier => {
          var tierBoxes = tier.querySelectorAll(".tier-box");
          if (tierBoxes && tierBoxes.length) {
            tierBoxes.forEach(box => box.classList.remove("active-tier"));
          }
        });
        if (state.bulkTiers) {
          var highestDiscount = state.bulkTiers.reduce((maxDiscount, tier, index) => {
            var bulkDiscountQty = Number(tier.bulk_discount_qty);
            var bulkDiscountPercent = Number(tier["bulk_discount_%"]);
            var quantity = state.productType == "pack" || state.productType == "accessory" ? getters.packsNeeded : getters.computedArea;
            if (quantity >= bulkDiscountQty && bulkDiscountPercent > maxDiscount) {
              appliedTierIndex = index;
              return bulkDiscountPercent;
            }
            return maxDiscount;
          }, 0);
          if (highestDiscount > 0) {
            price -= price * (highestDiscount / 100);
          } else {
            appliedTierIndex = -1;
          }
        } else if (state.bulkDiscountPrice && state.length >= state.bulkOrderThreshold) {
          price = state.bulkDiscountPrice;
          appliedTierIndex = 0;
        } else {
          appliedTierIndex = -1;
        }
        var activeTierElements = document.querySelectorAll("div[data-tier-index=\"".concat(appliedTierIndex, "\"] .tier-box"));
        if (activeTierElements && activeTierElements.length) {
          activeTierElements.forEach(el => el.classList.add("active-tier"));
        }
        if (state.selectedSize) {
          price = Number(state.selectedSize.rug_sale_price || state.selectedSize.rug_default_price);
        }
        return price;
      },
      pricePerM2: (state, getters) => {
        var price = getters.productPrice;
        if (state.productType == "pack") {
          price = price / state.packSize;
        }
        return price;
      },
      regularPricePerM2: (state, getters) => {
        if (state.productType == "pack") {
          return state.defaultRegularPrice / state.packSize;
        }
        return state.defaultRegularPrice;
      },
      computedTotal: (state, getters) => {
        var price = 0;
        if (state.productType == "pack") {
          price = getters.productPrice * getters.packsNeeded;
        } else if (state.productType == "roll") {
          price = getters.productPrice * getters.computedArea;
        }
        if (state.accessories.length > 0) {
          state.accessories.forEach(accessory => {
            price += accessory.quantity * accessory.price;
          });
        }
        var priceDisplay = document.querySelector("#productPriceDisplay .product-price");
        if (priceDisplay) {
          var perM2Text = state.productType === "pack" || state.productType === "roll" ? " <span class='text-base'>per m²</span>" : "";
          priceDisplay.innerHTML = formatCurrency(getters.pricePerM2) + perM2Text;
        }
        return price;
      },
      isFinanceEligible: (state, getters) => {
        var total = getters.computedTotal;
        return total >= 750 && total <= 10000;
      },
      availableFinanceTerms: (state, getters) => {
        var total = getters.computedTotal;
        if (total >= 3000 && total <= 10000) {
          return [6, 8, 10];
        } else if (total >= 1500 && total < 3000) {
          return [6, 8];
        } else if (total >= 750 && total < 1500) {
          return [6];
        }
        return [];
      },
      maxFinanceTerm: (state, getters) => {
        var terms = getters.availableFinanceTerms;
        return terms.length > 0 ? Math.max(...terms) : 0;
      },
      minMonthlyPayment: (state, getters) => {
        var total = getters.computedTotal;
        var maxTerm = getters.maxFinanceTerm;
        if (maxTerm === 0) return 0;
        var depositAmount = total * 0.1; // 10% minimum deposit
        var financeAmount = total - depositAmount;
        return financeAmount / maxTerm;
      }
    }
  });
}
function initProductCalculator() {
  var {
    createApp
  } = Vue;
  var productStore = createProductStore();
  var app = createApp(ProductCalculator);
  app.use(productStore);

  // Mount the app if element exists
  var mountElement = document.getElementById("product-calculator-app");
  if (mountElement) {
    app.mount(mountElement);
  }
}

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", initProductCalculator);

},{"./components/ProductCalculator.js":5,"./constants.js":12,"core-js/modules/web.dom-collections.iterator.js":142}],14:[function(require,module,exports){
'use strict';
var isCallable = require('../internals/is-callable');
var tryToString = require('../internals/try-to-string');

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a function');
};

},{"../internals/is-callable":69,"../internals/try-to-string":126}],15:[function(require,module,exports){
'use strict';
var isConstructor = require('../internals/is-constructor');
var tryToString = require('../internals/try-to-string');

var $TypeError = TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a constructor');
};

},{"../internals/is-constructor":70,"../internals/try-to-string":126}],16:[function(require,module,exports){
'use strict';
var isPossiblePrototype = require('../internals/is-possible-prototype');

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError("Can't set " + $String(argument) + ' as a prototype');
};

},{"../internals/is-possible-prototype":74}],17:[function(require,module,exports){
'use strict';
var wellKnownSymbol = require('../internals/well-known-symbol');
var create = require('../internals/object-create');
var defineProperty = require('../internals/object-define-property').f;

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

},{"../internals/object-create":88,"../internals/object-define-property":90,"../internals/well-known-symbol":132}],18:[function(require,module,exports){
'use strict';
var isPrototypeOf = require('../internals/object-is-prototype-of');

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw new $TypeError('Incorrect invocation');
};

},{"../internals/object-is-prototype-of":95}],19:[function(require,module,exports){
'use strict';
var isObject = require('../internals/is-object');

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw new $TypeError($String(argument) + ' is not an object');
};

},{"../internals/is-object":73}],20:[function(require,module,exports){
'use strict';
var toIndexedObject = require('../internals/to-indexed-object');
var toAbsoluteIndex = require('../internals/to-absolute-index');
var lengthOfArrayLike = require('../internals/length-of-array-like');

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

},{"../internals/length-of-array-like":83,"../internals/to-absolute-index":118,"../internals/to-indexed-object":119}],21:[function(require,module,exports){
'use strict';
var uncurryThis = require('../internals/function-uncurry-this');

module.exports = uncurryThis([].slice);

},{"../internals/function-uncurry-this":54}],22:[function(require,module,exports){
'use strict';
var wellKnownSymbol = require('../internals/well-known-symbol');

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

},{"../internals/well-known-symbol":132}],23:[function(require,module,exports){
'use strict';
var uncurryThis = require('../internals/function-uncurry-this');

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};

},{"../internals/function-uncurry-this":54}],24:[function(require,module,exports){
'use strict';
var TO_STRING_TAG_SUPPORT = require('../internals/to-string-tag-support');
var isCallable = require('../internals/is-callable');
var classofRaw = require('../internals/classof-raw');
var wellKnownSymbol = require('../internals/well-known-symbol');

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};

},{"../internals/classof-raw":23,"../internals/is-callable":69,"../internals/to-string-tag-support":125,"../internals/well-known-symbol":132}],25:[function(require,module,exports){
'use strict';
var hasOwn = require('../internals/has-own-property');
var ownKeys = require('../internals/own-keys');
var getOwnPropertyDescriptorModule = require('../internals/object-get-own-property-descriptor');
var definePropertyModule = require('../internals/object-define-property');

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

},{"../internals/has-own-property":60,"../internals/object-define-property":90,"../internals/object-get-own-property-descriptor":91,"../internals/own-keys":101}],26:[function(require,module,exports){
'use strict';
var fails = require('../internals/fails');

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

},{"../internals/fails":46}],27:[function(require,module,exports){
'use strict';
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function (value, done) {
  return { value: value, done: done };
};

},{}],28:[function(require,module,exports){
'use strict';
var DESCRIPTORS = require('../internals/descriptors');
var definePropertyModule = require('../internals/object-define-property');
var createPropertyDescriptor = require('../internals/create-property-descriptor');

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

},{"../internals/create-property-descriptor":29,"../internals/descriptors":33,"../internals/object-define-property":90}],29:[function(require,module,exports){
'use strict';
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

},{}],30:[function(require,module,exports){
'use strict';
var makeBuiltIn = require('../internals/make-built-in');
var defineProperty = require('../internals/object-define-property');

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};

},{"../internals/make-built-in":84,"../internals/object-define-property":90}],31:[function(require,module,exports){
'use strict';
var isCallable = require('../internals/is-callable');
var definePropertyModule = require('../internals/object-define-property');
var makeBuiltIn = require('../internals/make-built-in');
var defineGlobalProperty = require('../internals/define-global-property');

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

},{"../internals/define-global-property":32,"../internals/is-callable":69,"../internals/make-built-in":84,"../internals/object-define-property":90}],32:[function(require,module,exports){
'use strict';
var globalThis = require('../internals/global-this');

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(globalThis, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    globalThis[key] = value;
  } return value;
};

},{"../internals/global-this":59}],33:[function(require,module,exports){
'use strict';
var fails = require('../internals/fails');

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});

},{"../internals/fails":46}],34:[function(require,module,exports){
'use strict';
var globalThis = require('../internals/global-this');
var isObject = require('../internals/is-object');

var document = globalThis.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};

},{"../internals/global-this":59,"../internals/is-object":73}],35:[function(require,module,exports){
'use strict';
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

},{}],36:[function(require,module,exports){
'use strict';
// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = require('../internals/document-create-element');

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;

},{"../internals/document-create-element":34}],37:[function(require,module,exports){
'use strict';
// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

},{}],38:[function(require,module,exports){
'use strict';
var userAgent = require('../internals/environment-user-agent');

module.exports = /ipad|iphone|ipod/i.test(userAgent) && typeof Pebble != 'undefined';

},{"../internals/environment-user-agent":42}],39:[function(require,module,exports){
'use strict';
var userAgent = require('../internals/environment-user-agent');

// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);

},{"../internals/environment-user-agent":42}],40:[function(require,module,exports){
'use strict';
var ENVIRONMENT = require('../internals/environment');

module.exports = ENVIRONMENT === 'NODE';

},{"../internals/environment":44}],41:[function(require,module,exports){
'use strict';
var userAgent = require('../internals/environment-user-agent');

module.exports = /web0s(?!.*chrome)/i.test(userAgent);

},{"../internals/environment-user-agent":42}],42:[function(require,module,exports){
'use strict';
var globalThis = require('../internals/global-this');

var navigator = globalThis.navigator;
var userAgent = navigator && navigator.userAgent;

module.exports = userAgent ? String(userAgent) : '';

},{"../internals/global-this":59}],43:[function(require,module,exports){
'use strict';
var globalThis = require('../internals/global-this');
var userAgent = require('../internals/environment-user-agent');

var process = globalThis.process;
var Deno = globalThis.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;

},{"../internals/environment-user-agent":42,"../internals/global-this":59}],44:[function(require,module,exports){
'use strict';
/* global Bun, Deno -- detection */
var globalThis = require('../internals/global-this');
var userAgent = require('../internals/environment-user-agent');
var classof = require('../internals/classof-raw');

var userAgentStartsWith = function (string) {
  return userAgent.slice(0, string.length) === string;
};

module.exports = (function () {
  if (userAgentStartsWith('Bun/')) return 'BUN';
  if (userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
  if (userAgentStartsWith('Deno/')) return 'DENO';
  if (userAgentStartsWith('Node.js/')) return 'NODE';
  if (globalThis.Bun && typeof Bun.version == 'string') return 'BUN';
  if (globalThis.Deno && typeof Deno.version == 'object') return 'DENO';
  if (classof(globalThis.process) === 'process') return 'NODE';
  if (globalThis.window && globalThis.document) return 'BROWSER';
  return 'REST';
})();

},{"../internals/classof-raw":23,"../internals/environment-user-agent":42,"../internals/global-this":59}],45:[function(require,module,exports){
'use strict';
var globalThis = require('../internals/global-this');
var getOwnPropertyDescriptor = require('../internals/object-get-own-property-descriptor').f;
var createNonEnumerableProperty = require('../internals/create-non-enumerable-property');
var defineBuiltIn = require('../internals/define-built-in');
var defineGlobalProperty = require('../internals/define-global-property');
var copyConstructorProperties = require('../internals/copy-constructor-properties');
var isForced = require('../internals/is-forced');

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = globalThis;
  } else if (STATIC) {
    target = globalThis[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = globalThis[TARGET] && globalThis[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};

},{"../internals/copy-constructor-properties":25,"../internals/create-non-enumerable-property":28,"../internals/define-built-in":31,"../internals/define-global-property":32,"../internals/global-this":59,"../internals/is-forced":71,"../internals/object-get-own-property-descriptor":91}],46:[function(require,module,exports){
'use strict';
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

},{}],47:[function(require,module,exports){
'use strict';
var NATIVE_BIND = require('../internals/function-bind-native');

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});

},{"../internals/function-bind-native":49}],48:[function(require,module,exports){
'use strict';
var uncurryThis = require('../internals/function-uncurry-this-clause');
var aCallable = require('../internals/a-callable');
var NATIVE_BIND = require('../internals/function-bind-native');

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

},{"../internals/a-callable":14,"../internals/function-bind-native":49,"../internals/function-uncurry-this-clause":53}],49:[function(require,module,exports){
'use strict';
var fails = require('../internals/fails');

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

},{"../internals/fails":46}],50:[function(require,module,exports){
'use strict';
var NATIVE_BIND = require('../internals/function-bind-native');

var call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};

},{"../internals/function-bind-native":49}],51:[function(require,module,exports){
'use strict';
var DESCRIPTORS = require('../internals/descriptors');
var hasOwn = require('../internals/has-own-property');

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

},{"../internals/descriptors":33,"../internals/has-own-property":60}],52:[function(require,module,exports){
'use strict';
var uncurryThis = require('../internals/function-uncurry-this');
var aCallable = require('../internals/a-callable');

module.exports = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

},{"../internals/a-callable":14,"../internals/function-uncurry-this":54}],53:[function(require,module,exports){
'use strict';
var classofRaw = require('../internals/classof-raw');
var uncurryThis = require('../internals/function-uncurry-this');

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};

},{"../internals/classof-raw":23,"../internals/function-uncurry-this":54}],54:[function(require,module,exports){
'use strict';
var NATIVE_BIND = require('../internals/function-bind-native');

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};

},{"../internals/function-bind-native":49}],55:[function(require,module,exports){
'use strict';
var globalThis = require('../internals/global-this');
var isCallable = require('../internals/is-callable');

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(globalThis[namespace]) : globalThis[namespace] && globalThis[namespace][method];
};

},{"../internals/global-this":59,"../internals/is-callable":69}],56:[function(require,module,exports){
'use strict';
var classof = require('../internals/classof');
var getMethod = require('../internals/get-method');
var isNullOrUndefined = require('../internals/is-null-or-undefined');
var Iterators = require('../internals/iterators');
var wellKnownSymbol = require('../internals/well-known-symbol');

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};

},{"../internals/classof":24,"../internals/get-method":58,"../internals/is-null-or-undefined":72,"../internals/iterators":82,"../internals/well-known-symbol":132}],57:[function(require,module,exports){
'use strict';
var call = require('../internals/function-call');
var aCallable = require('../internals/a-callable');
var anObject = require('../internals/an-object');
var tryToString = require('../internals/try-to-string');
var getIteratorMethod = require('../internals/get-iterator-method');

var $TypeError = TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw new $TypeError(tryToString(argument) + ' is not iterable');
};

},{"../internals/a-callable":14,"../internals/an-object":19,"../internals/function-call":50,"../internals/get-iterator-method":56,"../internals/try-to-string":126}],58:[function(require,module,exports){
'use strict';
var aCallable = require('../internals/a-callable');
var isNullOrUndefined = require('../internals/is-null-or-undefined');

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};

},{"../internals/a-callable":14,"../internals/is-null-or-undefined":72}],59:[function(require,module,exports){
(function (global){(function (){
'use strict';
var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  check(typeof this == 'object' && this) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],60:[function(require,module,exports){
'use strict';
var uncurryThis = require('../internals/function-uncurry-this');
var toObject = require('../internals/to-object');

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};

},{"../internals/function-uncurry-this":54,"../internals/to-object":122}],61:[function(require,module,exports){
'use strict';
module.exports = {};

},{}],62:[function(require,module,exports){
'use strict';
module.exports = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};

},{}],63:[function(require,module,exports){
'use strict';
var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('document', 'documentElement');

},{"../internals/get-built-in":55}],64:[function(require,module,exports){
'use strict';
var DESCRIPTORS = require('../internals/descriptors');
var fails = require('../internals/fails');
var createElement = require('../internals/document-create-element');

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});

},{"../internals/descriptors":33,"../internals/document-create-element":34,"../internals/fails":46}],65:[function(require,module,exports){
'use strict';
var uncurryThis = require('../internals/function-uncurry-this');
var fails = require('../internals/fails');
var classof = require('../internals/classof-raw');

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) === 'String' ? split(it, '') : $Object(it);
} : $Object;

},{"../internals/classof-raw":23,"../internals/fails":46,"../internals/function-uncurry-this":54}],66:[function(require,module,exports){
'use strict';
var uncurryThis = require('../internals/function-uncurry-this');
var isCallable = require('../internals/is-callable');
var store = require('../internals/shared-store');

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;

},{"../internals/function-uncurry-this":54,"../internals/is-callable":69,"../internals/shared-store":113}],67:[function(require,module,exports){
'use strict';
var NATIVE_WEAK_MAP = require('../internals/weak-map-basic-detection');
var globalThis = require('../internals/global-this');
var isObject = require('../internals/is-object');
var createNonEnumerableProperty = require('../internals/create-non-enumerable-property');
var hasOwn = require('../internals/has-own-property');
var shared = require('../internals/shared-store');
var sharedKey = require('../internals/shared-key');
var hiddenKeys = require('../internals/hidden-keys');

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = globalThis.TypeError;
var WeakMap = globalThis.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

},{"../internals/create-non-enumerable-property":28,"../internals/global-this":59,"../internals/has-own-property":60,"../internals/hidden-keys":61,"../internals/is-object":73,"../internals/shared-key":112,"../internals/shared-store":113,"../internals/weak-map-basic-detection":131}],68:[function(require,module,exports){
'use strict';
var wellKnownSymbol = require('../internals/well-known-symbol');
var Iterators = require('../internals/iterators');

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};

},{"../internals/iterators":82,"../internals/well-known-symbol":132}],69:[function(require,module,exports){
'use strict';
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
module.exports = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};

},{}],70:[function(require,module,exports){
'use strict';
var uncurryThis = require('../internals/function-uncurry-this');
var fails = require('../internals/fails');
var isCallable = require('../internals/is-callable');
var classof = require('../internals/classof');
var getBuiltIn = require('../internals/get-built-in');
var inspectSource = require('../internals/inspect-source');

var noop = function () { /* empty */ };
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, [], argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

},{"../internals/classof":24,"../internals/fails":46,"../internals/function-uncurry-this":54,"../internals/get-built-in":55,"../internals/inspect-source":66,"../internals/is-callable":69}],71:[function(require,module,exports){
'use strict';
var fails = require('../internals/fails');
var isCallable = require('../internals/is-callable');

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;

},{"../internals/fails":46,"../internals/is-callable":69}],72:[function(require,module,exports){
'use strict';
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};

},{}],73:[function(require,module,exports){
'use strict';
var isCallable = require('../internals/is-callable');

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};

},{"../internals/is-callable":69}],74:[function(require,module,exports){
'use strict';
var isObject = require('../internals/is-object');

module.exports = function (argument) {
  return isObject(argument) || argument === null;
};

},{"../internals/is-object":73}],75:[function(require,module,exports){
'use strict';
module.exports = false;

},{}],76:[function(require,module,exports){
'use strict';
var getBuiltIn = require('../internals/get-built-in');
var isCallable = require('../internals/is-callable');
var isPrototypeOf = require('../internals/object-is-prototype-of');
var USE_SYMBOL_AS_UID = require('../internals/use-symbol-as-uid');

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};

},{"../internals/get-built-in":55,"../internals/is-callable":69,"../internals/object-is-prototype-of":95,"../internals/use-symbol-as-uid":128}],77:[function(require,module,exports){
'use strict';
var bind = require('../internals/function-bind-context');
var call = require('../internals/function-call');
var anObject = require('../internals/an-object');
var tryToString = require('../internals/try-to-string');
var isArrayIteratorMethod = require('../internals/is-array-iterator-method');
var lengthOfArrayLike = require('../internals/length-of-array-like');
var isPrototypeOf = require('../internals/object-is-prototype-of');
var getIterator = require('../internals/get-iterator');
var getIteratorMethod = require('../internals/get-iterator-method');
var iteratorClose = require('../internals/iterator-close');

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw new $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};

},{"../internals/an-object":19,"../internals/function-bind-context":48,"../internals/function-call":50,"../internals/get-iterator":57,"../internals/get-iterator-method":56,"../internals/is-array-iterator-method":68,"../internals/iterator-close":78,"../internals/length-of-array-like":83,"../internals/object-is-prototype-of":95,"../internals/try-to-string":126}],78:[function(require,module,exports){
'use strict';
var call = require('../internals/function-call');
var anObject = require('../internals/an-object');
var getMethod = require('../internals/get-method');

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};

},{"../internals/an-object":19,"../internals/function-call":50,"../internals/get-method":58}],79:[function(require,module,exports){
'use strict';
var IteratorPrototype = require('../internals/iterators-core').IteratorPrototype;
var create = require('../internals/object-create');
var createPropertyDescriptor = require('../internals/create-property-descriptor');
var setToStringTag = require('../internals/set-to-string-tag');
var Iterators = require('../internals/iterators');

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};

},{"../internals/create-property-descriptor":29,"../internals/iterators":82,"../internals/iterators-core":81,"../internals/object-create":88,"../internals/set-to-string-tag":111}],80:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var call = require('../internals/function-call');
var IS_PURE = require('../internals/is-pure');
var FunctionName = require('../internals/function-name');
var isCallable = require('../internals/is-callable');
var createIteratorConstructor = require('../internals/iterator-create-constructor');
var getPrototypeOf = require('../internals/object-get-prototype-of');
var setPrototypeOf = require('../internals/object-set-prototype-of');
var setToStringTag = require('../internals/set-to-string-tag');
var createNonEnumerableProperty = require('../internals/create-non-enumerable-property');
var defineBuiltIn = require('../internals/define-built-in');
var wellKnownSymbol = require('../internals/well-known-symbol');
var Iterators = require('../internals/iterators');
var IteratorsCore = require('../internals/iterators-core');

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};

},{"../internals/create-non-enumerable-property":28,"../internals/define-built-in":31,"../internals/export":45,"../internals/function-call":50,"../internals/function-name":51,"../internals/is-callable":69,"../internals/is-pure":75,"../internals/iterator-create-constructor":79,"../internals/iterators":82,"../internals/iterators-core":81,"../internals/object-get-prototype-of":94,"../internals/object-set-prototype-of":99,"../internals/set-to-string-tag":111,"../internals/well-known-symbol":132}],81:[function(require,module,exports){
'use strict';
var fails = require('../internals/fails');
var isCallable = require('../internals/is-callable');
var isObject = require('../internals/is-object');
var create = require('../internals/object-create');
var getPrototypeOf = require('../internals/object-get-prototype-of');
var defineBuiltIn = require('../internals/define-built-in');
var wellKnownSymbol = require('../internals/well-known-symbol');
var IS_PURE = require('../internals/is-pure');

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};

},{"../internals/define-built-in":31,"../internals/fails":46,"../internals/is-callable":69,"../internals/is-object":73,"../internals/is-pure":75,"../internals/object-create":88,"../internals/object-get-prototype-of":94,"../internals/well-known-symbol":132}],82:[function(require,module,exports){
arguments[4][61][0].apply(exports,arguments)
},{"dup":61}],83:[function(require,module,exports){
'use strict';
var toLength = require('../internals/to-length');

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};

},{"../internals/to-length":121}],84:[function(require,module,exports){
'use strict';
var uncurryThis = require('../internals/function-uncurry-this');
var fails = require('../internals/fails');
var isCallable = require('../internals/is-callable');
var hasOwn = require('../internals/has-own-property');
var DESCRIPTORS = require('../internals/descriptors');
var CONFIGURABLE_FUNCTION_NAME = require('../internals/function-name').CONFIGURABLE;
var inspectSource = require('../internals/inspect-source');
var InternalStateModule = require('../internals/internal-state');

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');

},{"../internals/descriptors":33,"../internals/fails":46,"../internals/function-name":51,"../internals/function-uncurry-this":54,"../internals/has-own-property":60,"../internals/inspect-source":66,"../internals/internal-state":67,"../internals/is-callable":69}],85:[function(require,module,exports){
'use strict';
var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

},{}],86:[function(require,module,exports){
'use strict';
var globalThis = require('../internals/global-this');
var safeGetBuiltIn = require('../internals/safe-get-built-in');
var bind = require('../internals/function-bind-context');
var macrotask = require('../internals/task').set;
var Queue = require('../internals/queue');
var IS_IOS = require('../internals/environment-is-ios');
var IS_IOS_PEBBLE = require('../internals/environment-is-ios-pebble');
var IS_WEBOS_WEBKIT = require('../internals/environment-is-webos-webkit');
var IS_NODE = require('../internals/environment-is-node');

var MutationObserver = globalThis.MutationObserver || globalThis.WebKitMutationObserver;
var document = globalThis.document;
var process = globalThis.process;
var Promise = globalThis.Promise;
var microtask = safeGetBuiltIn('queueMicrotask');
var notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask) {
  var queue = new Queue();

  var flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = bind(promise.then, promise);
    notify = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind(macrotask, globalThis);
    notify = function () {
      macrotask(flush);
    };
  }

  microtask = function (fn) {
    if (!queue.head) notify();
    queue.add(fn);
  };
}

module.exports = microtask;

},{"../internals/environment-is-ios":39,"../internals/environment-is-ios-pebble":38,"../internals/environment-is-node":40,"../internals/environment-is-webos-webkit":41,"../internals/function-bind-context":48,"../internals/global-this":59,"../internals/queue":107,"../internals/safe-get-built-in":109,"../internals/task":117}],87:[function(require,module,exports){
'use strict';
var aCallable = require('../internals/a-callable');

var $TypeError = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw new $TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};

},{"../internals/a-callable":14}],88:[function(require,module,exports){
'use strict';
/* global ActiveXObject -- old IE, WSH */
var anObject = require('../internals/an-object');
var definePropertiesModule = require('../internals/object-define-properties');
var enumBugKeys = require('../internals/enum-bug-keys');
var hiddenKeys = require('../internals/hidden-keys');
var html = require('../internals/html');
var documentCreateElement = require('../internals/document-create-element');
var sharedKey = require('../internals/shared-key');

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  // eslint-disable-next-line no-useless-assignment -- avoid memory leak
  activeXDocument = null;
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

},{"../internals/an-object":19,"../internals/document-create-element":34,"../internals/enum-bug-keys":37,"../internals/hidden-keys":61,"../internals/html":63,"../internals/object-define-properties":89,"../internals/shared-key":112}],89:[function(require,module,exports){
'use strict';
var DESCRIPTORS = require('../internals/descriptors');
var V8_PROTOTYPE_DEFINE_BUG = require('../internals/v8-prototype-define-bug');
var definePropertyModule = require('../internals/object-define-property');
var anObject = require('../internals/an-object');
var toIndexedObject = require('../internals/to-indexed-object');
var objectKeys = require('../internals/object-keys');

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};

},{"../internals/an-object":19,"../internals/descriptors":33,"../internals/object-define-property":90,"../internals/object-keys":97,"../internals/to-indexed-object":119,"../internals/v8-prototype-define-bug":129}],90:[function(require,module,exports){
'use strict';
var DESCRIPTORS = require('../internals/descriptors');
var IE8_DOM_DEFINE = require('../internals/ie8-dom-define');
var V8_PROTOTYPE_DEFINE_BUG = require('../internals/v8-prototype-define-bug');
var anObject = require('../internals/an-object');
var toPropertyKey = require('../internals/to-property-key');

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

},{"../internals/an-object":19,"../internals/descriptors":33,"../internals/ie8-dom-define":64,"../internals/to-property-key":124,"../internals/v8-prototype-define-bug":129}],91:[function(require,module,exports){
'use strict';
var DESCRIPTORS = require('../internals/descriptors');
var call = require('../internals/function-call');
var propertyIsEnumerableModule = require('../internals/object-property-is-enumerable');
var createPropertyDescriptor = require('../internals/create-property-descriptor');
var toIndexedObject = require('../internals/to-indexed-object');
var toPropertyKey = require('../internals/to-property-key');
var hasOwn = require('../internals/has-own-property');
var IE8_DOM_DEFINE = require('../internals/ie8-dom-define');

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};

},{"../internals/create-property-descriptor":29,"../internals/descriptors":33,"../internals/function-call":50,"../internals/has-own-property":60,"../internals/ie8-dom-define":64,"../internals/object-property-is-enumerable":98,"../internals/to-indexed-object":119,"../internals/to-property-key":124}],92:[function(require,module,exports){
'use strict';
var internalObjectKeys = require('../internals/object-keys-internal');
var enumBugKeys = require('../internals/enum-bug-keys');

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};

},{"../internals/enum-bug-keys":37,"../internals/object-keys-internal":96}],93:[function(require,module,exports){
'use strict';
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;

},{}],94:[function(require,module,exports){
'use strict';
var hasOwn = require('../internals/has-own-property');
var isCallable = require('../internals/is-callable');
var toObject = require('../internals/to-object');
var sharedKey = require('../internals/shared-key');
var CORRECT_PROTOTYPE_GETTER = require('../internals/correct-prototype-getter');

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};

},{"../internals/correct-prototype-getter":26,"../internals/has-own-property":60,"../internals/is-callable":69,"../internals/shared-key":112,"../internals/to-object":122}],95:[function(require,module,exports){
'use strict';
var uncurryThis = require('../internals/function-uncurry-this');

module.exports = uncurryThis({}.isPrototypeOf);

},{"../internals/function-uncurry-this":54}],96:[function(require,module,exports){
'use strict';
var uncurryThis = require('../internals/function-uncurry-this');
var hasOwn = require('../internals/has-own-property');
var toIndexedObject = require('../internals/to-indexed-object');
var indexOf = require('../internals/array-includes').indexOf;
var hiddenKeys = require('../internals/hidden-keys');

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};

},{"../internals/array-includes":20,"../internals/function-uncurry-this":54,"../internals/has-own-property":60,"../internals/hidden-keys":61,"../internals/to-indexed-object":119}],97:[function(require,module,exports){
'use strict';
var internalObjectKeys = require('../internals/object-keys-internal');
var enumBugKeys = require('../internals/enum-bug-keys');

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};

},{"../internals/enum-bug-keys":37,"../internals/object-keys-internal":96}],98:[function(require,module,exports){
'use strict';
var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

},{}],99:[function(require,module,exports){
'use strict';
/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = require('../internals/function-uncurry-this-accessor');
var isObject = require('../internals/is-object');
var requireObjectCoercible = require('../internals/require-object-coercible');
var aPossiblePrototype = require('../internals/a-possible-prototype');

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible(O);
    aPossiblePrototype(proto);
    if (!isObject(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

},{"../internals/a-possible-prototype":16,"../internals/function-uncurry-this-accessor":52,"../internals/is-object":73,"../internals/require-object-coercible":108}],100:[function(require,module,exports){
'use strict';
var call = require('../internals/function-call');
var isCallable = require('../internals/is-callable');
var isObject = require('../internals/is-object');

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw new $TypeError("Can't convert object to primitive value");
};

},{"../internals/function-call":50,"../internals/is-callable":69,"../internals/is-object":73}],101:[function(require,module,exports){
'use strict';
var getBuiltIn = require('../internals/get-built-in');
var uncurryThis = require('../internals/function-uncurry-this');
var getOwnPropertyNamesModule = require('../internals/object-get-own-property-names');
var getOwnPropertySymbolsModule = require('../internals/object-get-own-property-symbols');
var anObject = require('../internals/an-object');

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};

},{"../internals/an-object":19,"../internals/function-uncurry-this":54,"../internals/get-built-in":55,"../internals/object-get-own-property-names":92,"../internals/object-get-own-property-symbols":93}],102:[function(require,module,exports){
'use strict';
module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

},{}],103:[function(require,module,exports){
'use strict';
var globalThis = require('../internals/global-this');
var NativePromiseConstructor = require('../internals/promise-native-constructor');
var isCallable = require('../internals/is-callable');
var isForced = require('../internals/is-forced');
var inspectSource = require('../internals/inspect-source');
var wellKnownSymbol = require('../internals/well-known-symbol');
var ENVIRONMENT = require('../internals/environment');
var IS_PURE = require('../internals/is-pure');
var V8_VERSION = require('../internals/environment-v8-version');

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var SPECIES = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(globalThis.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
  if (IS_PURE && !(NativePromisePrototype['catch'] && NativePromisePrototype['finally'])) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (ENVIRONMENT === 'BROWSER' || ENVIRONMENT === 'DENO') && !NATIVE_PROMISE_REJECTION_EVENT;
});

module.exports = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
  SUBCLASSING: SUBCLASSING
};

},{"../internals/environment":44,"../internals/environment-v8-version":43,"../internals/global-this":59,"../internals/inspect-source":66,"../internals/is-callable":69,"../internals/is-forced":71,"../internals/is-pure":75,"../internals/promise-native-constructor":104,"../internals/well-known-symbol":132}],104:[function(require,module,exports){
'use strict';
var globalThis = require('../internals/global-this');

module.exports = globalThis.Promise;

},{"../internals/global-this":59}],105:[function(require,module,exports){
'use strict';
var anObject = require('../internals/an-object');
var isObject = require('../internals/is-object');
var newPromiseCapability = require('../internals/new-promise-capability');

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

},{"../internals/an-object":19,"../internals/is-object":73,"../internals/new-promise-capability":87}],106:[function(require,module,exports){
'use strict';
var NativePromiseConstructor = require('../internals/promise-native-constructor');
var checkCorrectnessOfIteration = require('../internals/check-correctness-of-iteration');
var FORCED_PROMISE_CONSTRUCTOR = require('../internals/promise-constructor-detection').CONSTRUCTOR;

module.exports = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor.all(iterable).then(undefined, function () { /* empty */ });
});

},{"../internals/check-correctness-of-iteration":22,"../internals/promise-constructor-detection":103,"../internals/promise-native-constructor":104}],107:[function(require,module,exports){
'use strict';
var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

module.exports = Queue;

},{}],108:[function(require,module,exports){
'use strict';
var isNullOrUndefined = require('../internals/is-null-or-undefined');

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
  return it;
};

},{"../internals/is-null-or-undefined":72}],109:[function(require,module,exports){
'use strict';
var globalThis = require('../internals/global-this');
var DESCRIPTORS = require('../internals/descriptors');

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
module.exports = function (name) {
  if (!DESCRIPTORS) return globalThis[name];
  var descriptor = getOwnPropertyDescriptor(globalThis, name);
  return descriptor && descriptor.value;
};

},{"../internals/descriptors":33,"../internals/global-this":59}],110:[function(require,module,exports){
'use strict';
var getBuiltIn = require('../internals/get-built-in');
var defineBuiltInAccessor = require('../internals/define-built-in-accessor');
var wellKnownSymbol = require('../internals/well-known-symbol');
var DESCRIPTORS = require('../internals/descriptors');

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineBuiltInAccessor(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

},{"../internals/define-built-in-accessor":30,"../internals/descriptors":33,"../internals/get-built-in":55,"../internals/well-known-symbol":132}],111:[function(require,module,exports){
'use strict';
var defineProperty = require('../internals/object-define-property').f;
var hasOwn = require('../internals/has-own-property');
var wellKnownSymbol = require('../internals/well-known-symbol');

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};

},{"../internals/has-own-property":60,"../internals/object-define-property":90,"../internals/well-known-symbol":132}],112:[function(require,module,exports){
'use strict';
var shared = require('../internals/shared');
var uid = require('../internals/uid');

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

},{"../internals/shared":114,"../internals/uid":127}],113:[function(require,module,exports){
'use strict';
var IS_PURE = require('../internals/is-pure');
var globalThis = require('../internals/global-this');
var defineGlobalProperty = require('../internals/define-global-property');

var SHARED = '__core-js_shared__';
var store = module.exports = globalThis[SHARED] || defineGlobalProperty(SHARED, {});

(store.versions || (store.versions = [])).push({
  version: '3.41.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2025 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.41.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

},{"../internals/define-global-property":32,"../internals/global-this":59,"../internals/is-pure":75}],114:[function(require,module,exports){
'use strict';
var store = require('../internals/shared-store');

module.exports = function (key, value) {
  return store[key] || (store[key] = value || {});
};

},{"../internals/shared-store":113}],115:[function(require,module,exports){
'use strict';
var anObject = require('../internals/an-object');
var aConstructor = require('../internals/a-constructor');
var isNullOrUndefined = require('../internals/is-null-or-undefined');
var wellKnownSymbol = require('../internals/well-known-symbol');

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
};

},{"../internals/a-constructor":15,"../internals/an-object":19,"../internals/is-null-or-undefined":72,"../internals/well-known-symbol":132}],116:[function(require,module,exports){
'use strict';
/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = require('../internals/environment-v8-version');
var fails = require('../internals/fails');
var globalThis = require('../internals/global-this');

var $String = globalThis.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

},{"../internals/environment-v8-version":43,"../internals/fails":46,"../internals/global-this":59}],117:[function(require,module,exports){
'use strict';
var globalThis = require('../internals/global-this');
var apply = require('../internals/function-apply');
var bind = require('../internals/function-bind-context');
var isCallable = require('../internals/is-callable');
var hasOwn = require('../internals/has-own-property');
var fails = require('../internals/fails');
var html = require('../internals/html');
var arraySlice = require('../internals/array-slice');
var createElement = require('../internals/document-create-element');
var validateArgumentsLength = require('../internals/validate-arguments-length');
var IS_IOS = require('../internals/environment-is-ios');
var IS_NODE = require('../internals/environment-is-node');

var set = globalThis.setImmediate;
var clear = globalThis.clearImmediate;
var process = globalThis.process;
var Dispatch = globalThis.Dispatch;
var Function = globalThis.Function;
var MessageChannel = globalThis.MessageChannel;
var String = globalThis.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = globalThis.location;
});

var run = function (id) {
  if (hasOwn(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  globalThis.postMessage(String(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function(handler);
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    globalThis.addEventListener &&
    isCallable(globalThis.postMessage) &&
    !globalThis.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    globalThis.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};

},{"../internals/array-slice":21,"../internals/document-create-element":34,"../internals/environment-is-ios":39,"../internals/environment-is-node":40,"../internals/fails":46,"../internals/function-apply":47,"../internals/function-bind-context":48,"../internals/global-this":59,"../internals/has-own-property":60,"../internals/html":63,"../internals/is-callable":69,"../internals/validate-arguments-length":130}],118:[function(require,module,exports){
'use strict';
var toIntegerOrInfinity = require('../internals/to-integer-or-infinity');

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

},{"../internals/to-integer-or-infinity":120}],119:[function(require,module,exports){
'use strict';
// toObject with fallback for non-array-like ES3 strings
var IndexedObject = require('../internals/indexed-object');
var requireObjectCoercible = require('../internals/require-object-coercible');

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};

},{"../internals/indexed-object":65,"../internals/require-object-coercible":108}],120:[function(require,module,exports){
'use strict';
var trunc = require('../internals/math-trunc');

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

},{"../internals/math-trunc":85}],121:[function(require,module,exports){
'use strict';
var toIntegerOrInfinity = require('../internals/to-integer-or-infinity');

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  var len = toIntegerOrInfinity(argument);
  return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

},{"../internals/to-integer-or-infinity":120}],122:[function(require,module,exports){
'use strict';
var requireObjectCoercible = require('../internals/require-object-coercible');

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};

},{"../internals/require-object-coercible":108}],123:[function(require,module,exports){
'use strict';
var call = require('../internals/function-call');
var isObject = require('../internals/is-object');
var isSymbol = require('../internals/is-symbol');
var getMethod = require('../internals/get-method');
var ordinaryToPrimitive = require('../internals/ordinary-to-primitive');
var wellKnownSymbol = require('../internals/well-known-symbol');

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw new $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

},{"../internals/function-call":50,"../internals/get-method":58,"../internals/is-object":73,"../internals/is-symbol":76,"../internals/ordinary-to-primitive":100,"../internals/well-known-symbol":132}],124:[function(require,module,exports){
'use strict';
var toPrimitive = require('../internals/to-primitive');
var isSymbol = require('../internals/is-symbol');

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

},{"../internals/is-symbol":76,"../internals/to-primitive":123}],125:[function(require,module,exports){
'use strict';
var wellKnownSymbol = require('../internals/well-known-symbol');

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';

},{"../internals/well-known-symbol":132}],126:[function(require,module,exports){
'use strict';
var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};

},{}],127:[function(require,module,exports){
'use strict';
var uncurryThis = require('../internals/function-uncurry-this');

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};

},{"../internals/function-uncurry-this":54}],128:[function(require,module,exports){
'use strict';
/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = require('../internals/symbol-constructor-detection');

module.exports = NATIVE_SYMBOL &&
  !Symbol.sham &&
  typeof Symbol.iterator == 'symbol';

},{"../internals/symbol-constructor-detection":116}],129:[function(require,module,exports){
'use strict';
var DESCRIPTORS = require('../internals/descriptors');
var fails = require('../internals/fails');

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});

},{"../internals/descriptors":33,"../internals/fails":46}],130:[function(require,module,exports){
'use strict';
var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw new $TypeError('Not enough arguments');
  return passed;
};

},{}],131:[function(require,module,exports){
'use strict';
var globalThis = require('../internals/global-this');
var isCallable = require('../internals/is-callable');

var WeakMap = globalThis.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));

},{"../internals/global-this":59,"../internals/is-callable":69}],132:[function(require,module,exports){
'use strict';
var globalThis = require('../internals/global-this');
var shared = require('../internals/shared');
var hasOwn = require('../internals/has-own-property');
var uid = require('../internals/uid');
var NATIVE_SYMBOL = require('../internals/symbol-constructor-detection');
var USE_SYMBOL_AS_UID = require('../internals/use-symbol-as-uid');

var Symbol = globalThis.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

},{"../internals/global-this":59,"../internals/has-own-property":60,"../internals/shared":114,"../internals/symbol-constructor-detection":116,"../internals/uid":127,"../internals/use-symbol-as-uid":128}],133:[function(require,module,exports){
'use strict';
var toIndexedObject = require('../internals/to-indexed-object');
var addToUnscopables = require('../internals/add-to-unscopables');
var Iterators = require('../internals/iterators');
var InternalStateModule = require('../internals/internal-state');
var defineProperty = require('../internals/object-define-property').f;
var defineIterator = require('../internals/iterator-define');
var createIterResultObject = require('../internals/create-iter-result-object');
var IS_PURE = require('../internals/is-pure');
var DESCRIPTORS = require('../internals/descriptors');

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = null;
    return createIterResultObject(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject(index, false);
    case 'values': return createIterResultObject(target[index], false);
  } return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

},{"../internals/add-to-unscopables":17,"../internals/create-iter-result-object":27,"../internals/descriptors":33,"../internals/internal-state":67,"../internals/is-pure":75,"../internals/iterator-define":80,"../internals/iterators":82,"../internals/object-define-property":90,"../internals/to-indexed-object":119}],134:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var call = require('../internals/function-call');
var aCallable = require('../internals/a-callable');
var newPromiseCapabilityModule = require('../internals/new-promise-capability');
var perform = require('../internals/perform');
var iterate = require('../internals/iterate');
var PROMISE_STATICS_INCORRECT_ITERATION = require('../internals/promise-statics-incorrect-iteration');

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

},{"../internals/a-callable":14,"../internals/export":45,"../internals/function-call":50,"../internals/iterate":77,"../internals/new-promise-capability":87,"../internals/perform":102,"../internals/promise-statics-incorrect-iteration":106}],135:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var IS_PURE = require('../internals/is-pure');
var FORCED_PROMISE_CONSTRUCTOR = require('../internals/promise-constructor-detection').CONSTRUCTOR;
var NativePromiseConstructor = require('../internals/promise-native-constructor');
var getBuiltIn = require('../internals/get-built-in');
var isCallable = require('../internals/is-callable');
var defineBuiltIn = require('../internals/define-built-in');

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}

},{"../internals/define-built-in":31,"../internals/export":45,"../internals/get-built-in":55,"../internals/is-callable":69,"../internals/is-pure":75,"../internals/promise-constructor-detection":103,"../internals/promise-native-constructor":104}],136:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var IS_PURE = require('../internals/is-pure');
var IS_NODE = require('../internals/environment-is-node');
var globalThis = require('../internals/global-this');
var call = require('../internals/function-call');
var defineBuiltIn = require('../internals/define-built-in');
var setPrototypeOf = require('../internals/object-set-prototype-of');
var setToStringTag = require('../internals/set-to-string-tag');
var setSpecies = require('../internals/set-species');
var aCallable = require('../internals/a-callable');
var isCallable = require('../internals/is-callable');
var isObject = require('../internals/is-object');
var anInstance = require('../internals/an-instance');
var speciesConstructor = require('../internals/species-constructor');
var task = require('../internals/task').set;
var microtask = require('../internals/microtask');
var hostReportErrors = require('../internals/host-report-errors');
var perform = require('../internals/perform');
var Queue = require('../internals/queue');
var InternalStateModule = require('../internals/internal-state');
var NativePromiseConstructor = require('../internals/promise-native-constructor');
var PromiseConstructorDetection = require('../internals/promise-constructor-detection');
var newPromiseCapabilityModule = require('../internals/new-promise-capability');

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var PromiseConstructor = NativePromiseConstructor;
var PromisePrototype = NativePromisePrototype;
var TypeError = globalThis.TypeError;
var document = globalThis.document;
var process = globalThis.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document && document.createEvent && globalThis.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state === FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(new TypeError('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    globalThis.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = globalThis['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call(task, globalThis, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call(task, globalThis, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw new TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    call(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: null
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state === PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };

  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && isCallable(NativePromiseConstructor) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

// `Promise` constructor
// https://tc39.es/ecma262/#sec-promise-executor
$({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);

},{"../internals/a-callable":14,"../internals/an-instance":18,"../internals/define-built-in":31,"../internals/environment-is-node":40,"../internals/export":45,"../internals/function-call":50,"../internals/global-this":59,"../internals/host-report-errors":62,"../internals/internal-state":67,"../internals/is-callable":69,"../internals/is-object":73,"../internals/is-pure":75,"../internals/microtask":86,"../internals/new-promise-capability":87,"../internals/object-set-prototype-of":99,"../internals/perform":102,"../internals/promise-constructor-detection":103,"../internals/promise-native-constructor":104,"../internals/queue":107,"../internals/set-species":110,"../internals/set-to-string-tag":111,"../internals/species-constructor":115,"../internals/task":117}],137:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var IS_PURE = require('../internals/is-pure');
var NativePromiseConstructor = require('../internals/promise-native-constructor');
var fails = require('../internals/fails');
var getBuiltIn = require('../internals/get-built-in');
var isCallable = require('../internals/is-callable');
var speciesConstructor = require('../internals/species-constructor');
var promiseResolve = require('../internals/promise-resolve');
var defineBuiltIn = require('../internals/define-built-in');

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromiseConstructor && fails(function () {
  // eslint-disable-next-line unicorn/no-thenable -- required for testing
  NativePromisePrototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = isCallable(onFinally);
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['finally'];
  if (NativePromisePrototype['finally'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'finally', method, { unsafe: true });
  }
}

},{"../internals/define-built-in":31,"../internals/export":45,"../internals/fails":46,"../internals/get-built-in":55,"../internals/is-callable":69,"../internals/is-pure":75,"../internals/promise-native-constructor":104,"../internals/promise-resolve":105,"../internals/species-constructor":115}],138:[function(require,module,exports){
'use strict';
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
require('../modules/es.promise.constructor');
require('../modules/es.promise.all');
require('../modules/es.promise.catch');
require('../modules/es.promise.race');
require('../modules/es.promise.reject');
require('../modules/es.promise.resolve');

},{"../modules/es.promise.all":134,"../modules/es.promise.catch":135,"../modules/es.promise.constructor":136,"../modules/es.promise.race":139,"../modules/es.promise.reject":140,"../modules/es.promise.resolve":141}],139:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var call = require('../internals/function-call');
var aCallable = require('../internals/a-callable');
var newPromiseCapabilityModule = require('../internals/new-promise-capability');
var perform = require('../internals/perform');
var iterate = require('../internals/iterate');
var PROMISE_STATICS_INCORRECT_ITERATION = require('../internals/promise-statics-incorrect-iteration');

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

},{"../internals/a-callable":14,"../internals/export":45,"../internals/function-call":50,"../internals/iterate":77,"../internals/new-promise-capability":87,"../internals/perform":102,"../internals/promise-statics-incorrect-iteration":106}],140:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var newPromiseCapabilityModule = require('../internals/new-promise-capability');
var FORCED_PROMISE_CONSTRUCTOR = require('../internals/promise-constructor-detection').CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    var capabilityReject = capability.reject;
    capabilityReject(r);
    return capability.promise;
  }
});

},{"../internals/export":45,"../internals/new-promise-capability":87,"../internals/promise-constructor-detection":103}],141:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var getBuiltIn = require('../internals/get-built-in');
var IS_PURE = require('../internals/is-pure');
var NativePromiseConstructor = require('../internals/promise-native-constructor');
var FORCED_PROMISE_CONSTRUCTOR = require('../internals/promise-constructor-detection').CONSTRUCTOR;
var promiseResolve = require('../internals/promise-resolve');

var PromiseConstructorWrapper = getBuiltIn('Promise');
var CHECK_WRAPPER = IS_PURE && !FORCED_PROMISE_CONSTRUCTOR;

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$({ target: 'Promise', stat: true, forced: IS_PURE || FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor : this, x);
  }
});

},{"../internals/export":45,"../internals/get-built-in":55,"../internals/is-pure":75,"../internals/promise-constructor-detection":103,"../internals/promise-native-constructor":104,"../internals/promise-resolve":105}],142:[function(require,module,exports){
'use strict';
var globalThis = require('../internals/global-this');
var DOMIterables = require('../internals/dom-iterables');
var DOMTokenListPrototype = require('../internals/dom-token-list-prototype');
var ArrayIteratorMethods = require('../modules/es.array.iterator');
var createNonEnumerableProperty = require('../internals/create-non-enumerable-property');
var setToStringTag = require('../internals/set-to-string-tag');
var wellKnownSymbol = require('../internals/well-known-symbol');

var ITERATOR = wellKnownSymbol('iterator');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    setToStringTag(CollectionPrototype, COLLECTION_NAME, true);
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(globalThis[COLLECTION_NAME] && globalThis[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

},{"../internals/create-non-enumerable-property":28,"../internals/dom-iterables":35,"../internals/dom-token-list-prototype":36,"../internals/global-this":59,"../internals/set-to-string-tag":111,"../internals/well-known-symbol":132,"../modules/es.array.iterator":133}]},{},[13])

